/* tslint:disable */
/* eslint-disable */
/**
 * Auto-generated API paths from OpenAPI spec with type mappings
 * 
 * Usage with automatic type inference:
 * import { API_URL } from '@/types/generated-paths';
 * 
 * // Simple path
 * const { data } = useQuery([KEY], () => 
 *   api.get(API_URL.EMPLOYEES)
 * );
 * 
 * // Path with parameters
 * const { data } = useQuery([KEY, accountId], () => 
 *   api.get(API_URL.ACTIVITIES_ACCOUNTS(accountId))
 * );
 * 
 * // data.data is automatically typed!
 */

import type {
  IAggregatedAccountActivityDto,
  IClaimActivityDetails,
  IBankingActivityDetails,
  ICardPurseDto,
  ICardPurseAccountDto,
  ICardPurseAccessUpdateDto,
  ICarrierConfigResponseAggregatorDtoPage,
  ICarrierConfigResponseAggregatorDto,
  ICreateCarrierConfigAggregatorDto,
  IChecksResponseAggregatorDtoPage,
  ICheckReissueDto,
  ICheckVoidDto,
  ICipIdologyResponseDto,
  IClaimInfoResponseDto,
  ICreateClaimAggregatorDto,
  IPaymentDetailsResponseDto,
  IClaimRepaymentAggregatedDto,
  IRetryClaimPaymentDto,
  IClaimsResponseAggregatorDtoPage,
  IPageClaimDto,
  IClaimSearchDto,
  IClaimInfoAggregatorResponseDto,
  IManualClaimUpdateDto,
  IDocumentIdDto,
  IPrivateClaimInfoResponseDto,
  IClaimRejectedAggregatorDto,
  IRelatedClaimEnhancedDto,
  IClaimRepaymentStartDto,
  IMonitorContributionAggregateResponseDto,
  IRecurringContributionResponseDto,
  IRecurringContributionAggregateResponseDto,
  IRecurringContributionAggregatorRequestDto,
  IRecurringContributionPatchUpdateRequestDto,
  IContributionRequestInfoAggregateDto,
  IEmployeeContributionLimitResponse,
  IContributionSegmentResponseDto,
  IAggregatorManualContributionRequestDto,
  IEeContributionResponseDto,
  IEeContributionRequestDto,
  IPaymentMethodResponseDto,
  ICreateDebitCardRequest,
  IDependentInfoDto,
  IDependentResponseDto,
  IDependentRequestDto,
  IDependentUpdateDto,
  IDocumentFilesUrlDto,
  ICreateDocumentAggregatorDto,
  IAggregatedEmployeeLinkedAccountsDto,
  IBalanceReminderResponseDto,
  IEmployeeMatchDetailsAggregatorDto,
  IEmployeeBadRecordRequestDto,
  IEnrollmentDto,
  IExpressSetupDto,
  IExpressSetupExtendedDto,
  IFileActorDto,
  IFileRecordErrorAggregatorDto,
  ISearchFileDto,
  IFileDetailsAggregatorResponseDto,
  IHealthPlanBaseDto,
  IHealthPlanDto,
  IHealthPlanCreateDto,
  IHealthPlanUpdateDto,
  IInvestorDto,
  IFundingPatchDto,
  IInvestmentOperationRequestDto,
  IInvestmentHoldingsDto,
  IInvestmentModelSwitchDto,
  IAutoInvestmentSchedulerResponseDto,
  IAutoInvestmentSchedulerUpdateDto,
  IAutoInvestmentSchedulerRequestDto,
  ITradeCreateDto,
  IInvoiceDashboardPageDto,
  IInvoiceDetailsAggregatorDto,
  ILockboxDetailsAggregatorDto,
  ILockboxDto,
  IUpdateLockboxAggregatorDto,
  ICoverageDto,
  IEnrollmentMatrixDto,
  IOrganizationLockDto,
  IOrganizationExpressSetupResponseDto,
  IOrganizationInfoDto,
  IQrCodeOverridablePropertiesDto,
  IEmployerTerminationPropertiesDto,
  IEmployerTerminationPropertiesCreateDto,
  IPaymentAccountResponseDto,
  IPaymentAccountRequestDto,
  IPaymentMethodSetupResponseDto,
  IPaymentMethodSetupRequestDto,
  IUpdatePaymentMethodRequestDto,
  IFiservCardVaultToken,
  IPrefundSummaryDto,
  IProcessingRuleDto,
  IProviderInfoDto,
  ICreateProviderAggregatorDto,
  ISignUpRequestDto,
  IClaimTransferCreateBatchDto,
  IClaimTransferAccountDto,
  IOcrClaimDto,
  IOcrReceiptResponseDto,
  IOcrDto,
  IServiceConfigDto,
  IUpdateProcessingRuleTiersDto,
  IFundingLevelSwitchingDto,
  IPlanIdsDto,
  IDeductibleUpdateRequestDto,
  ITriggerDto,
  IPlanTerminationPropertiesDto,
  IDeductiblePreviewRequestDto,
  IUpdatePayoutRuleTypeRequestDto,
  IPlanTerminationPropertiesPatchDto,
  IEnrollmentMatrixPatchDto,
  IServiceDto,
  IDeductibleTierDto,
  ISpendLimitPeriodDto,
  ISpendLimitPeriodRemainingDto,
  ISpendLimitRemainingByAccountDto,
  IPersonSpendLimitDto,
  IMpTableDto,
  IIrsLimitDto,
  IIrsLimitLiteDto,
  IPolicyLimitsDto,
  IHealthPolicyDto,
  ICovTableDto,
  ICategorySpendLimitDto,
  IAccountOrderDto,
  IAccountOrderMatrixDto,
  IPlanYearDto,
  ISequenceDto,
  IPayrollCalendarAggregatorResponseDto,
  IPayrollCalendarExtendedAggregatorResponseDto,
  IPlanDto,
  IPatchLinkedSystemTemplatesDto,
  IRenewalRecordExtendedDto,
  IRenewalRecordDto,
  IEmployeeInfoResponseDto,
  IEmployeeInfoCreateAggregatorDto,
  IEmployeeInfoPatchDto,
  IEmployeeInfoUpdateDto,
  IEmployeeInfoAdminPatchDto,
  IEmployerTerminationPropertiesV3Dto,
  IContributionRecordUpdateRequestDto,
  IIrsLimitsSearchRequest,
  IPushProvisionResponse,
  IPushProvisionRequest,
  IPushProvisionEmailVerificationRequest,
  IContributionRecordBulkUpdateRequestDto,
  IUnmatchedPushTotalBalanceResponse,
  IContributionRecordAvailableTaxYearsResponseDto,
  IRecordTaxYearChangeResponseDto,
  IGetWalletDataResponse,
  ICardHolderWithDependentDto,
  ILetterOfMedicalNecessityDto,
  ILetterOfMedicalNecessityCreateDto,
  ICreateTransactionWorkflowDto,
  ICalculationAccountAmountResponseDto,
  ICalculationAccountAmountRequestDto,
  IFeeTransferCreateDto,
  IFeeReversalCreateDto,
  IBalanceAdjustmentRequestDto,
  IPlanOmniBalanceHistoryDto,
  ICustomPageEncryptedAccountDto,
  IAccountTypeDto,
  IAccountCategoryDto,
  IPublicKeyDto,
  IEncryptedAccountDto,
  IUpdateEncryptedExternalBankAccountDto,
  ICreateEncryptedExternalBankAccountDto,
  IAccountCloseMessage,
  ICalculateTotalBalanceResponseDto,
  ICalculateTotalBalanceRequestDto,
  IAccountVerificationStatusResponseDto,
  ICustomPageAccountDto,
  IAccountDto,
  IAccountNumberDto,
  IAccountClosureAmountsDto,
  IPersonInfoDto,
  IPublicEmployeeInfoDto,
  ISsoUserSignUpDto,
  IFraudReviewRequestDto,
  IBeneficiaryUpdateDto,
  IUpdateAuthorizedUserDto,
  IPersonRegistrationVerifyResponseDto,
  IPersonRegistrationVerifyRequestDto,
  IUsernameRegistrationVerifyRequestDto,
  IForgotUsernameRequestDto,
  IMobileAppProblemReportRequestDto,
  IMobileAppFeedbackRequestDto,
  ICombineHsaFileResponseDto,
  IVerificationCodeRequestCreateDto,
  ICreateAuthorizedUserDto,
  IEmployeeLinkResponseDto,
  IEmployeeAutopayPropertiesDto,
  IVerificationCodeValidationResponseDto,
  ILinkVerificationCodeValidationRequestDto,
  IVerificationCodeValidationRequestDto,
  IDependentNameDto,
  ISsnInfoDto,
  IMobileAppFeedbackReminderResponseDto,
  IEnumInfoDto,
  IEmployeeViewDto,
  IEmployeePersonalInfoDto,
  IEmployeeNameDto,
  ILinkedEmployeeInfoDto,
  ICustomPageEmployeeEmployerInfoDto,
  ICombineHsaRequestDto,
  IRoleUpdateDto,
  IOrganizationPropertiesStateConfigRequestDto,
  IEmployeeRoleUpdateDto,
  IZendeskMessagingTokenResponseDto,
  IInitiateAuthResponseDto,
  IInitiateAuthRequestDto,
  IRoleCreateDto,
  IRevokeTokenRequestDto,
  IResendConfirmationCodeRequestDto,
  ITokenResponseDto,
  ITokenRequestDto,
  IForgotPasswordRequestDto,
  IUserChangePasswordDto,
  IUserConfirmForgotPasswordDto,
  ICodeExchangeRequestDto,
  IUnlockMfaDto,
  IChannelRequestDto,
  ICodeRequestDto,
  IChangeUserLockingRequest,
  IAppClientInfoDto,
  IConfirmSignUpRequestDto,
  IPasswordResetLinkValidationResponseDto,
  IOrganizationPropertiesStatesDto,
  IContactInfoDto,
  IContactSaveDto,
  IClaimsTeamInfoDto,
  IContactSaveClaimsTeamsDto,
  IClaimsTeamUpdateDto,
  IClaimsTeamSaveContactDto,
  IExpressContactSaveDto,
  IContactDataDto,
  ICustomPageContactInfoDto,
  IContactByClaimsTeamsDto,
  IClaimsTeamCreateDto,
  IExpressContactStatusDto,
  IHashIdOverridablePropertiesDto,
  IMobileAppThemeDto,
  IExpressSetupInfoDto,
  IIdSourceTypeDto,
  IRelationshipTypeDto,
  IHsaCustodianTypeDto,
  IEligibleDependentsDto,
  IElectronicFundingDto,
  ICheckWritingTypeDto,
  IBusinessEntityTypeDto,
  IBankMethodsDto,
  IContactCountDto,
  IContactInfoLiteDto,
  IOrganizationPropertyInfoDto,
  IOverridablePropertiesInfoDto,
  IPreferredDto,
  IOrganizationReactivationRequest,
  IOrganizationPhoneInfoDto,
  IOverridablePropertiesValidateDto,
  IPropagateOverridablePropertiesResponse,
  IPropagateOverridablePropertiesRequest,
  ICustomPageOrganizationShortDto,
  ISearchOrganizationDto,
  IOrganizationLogoDto,
  IOrganizationEmailTemplateLogoDto,
  INotificationPropertiesInfoDto,
  IEmployeeOverridablePropertiesInfoDto,
  IOrganizationNoteDto,
  IOrganizationViewDto,
  IOrganizationShortDto,
  IOrganizationNameDto,
  IHierarchyNode,
  IOrganizationLiteDto,
  IApplyUnmatchedInvoicesRequestDto,
  ITransactorInfoDto,
  IPageUnappliedPushInvoiceDto,
  IStateInfoDto,
  ICountryInfoDto,
  IPayoutDefinitionDto,
  IPayoutDefinitionUpdateDto,
  ICopayGroupDto,
  IServiceCreateDto,
  IPlanReactivationDto,
  IPlanCodeValidationResponseDto,
  IPlanCodeValidationRequestDto,
  IPayoutDefinitionCreateDto,
  IServiceUpdateRequest,
  IPlanTemplateConfigDto,
  IPolicyEnrollmentDto,
  IPolicyStatusDto,
  IPolicySpendLimitsDto,
  IPolicyElectionDto,
  IHealthPlanTierStatsDto,
  IPlanGracePeriodDto,
  IPriorPlanDto,
  IPlanPrimaryConfigLiteDto,
  IPlanYearPlanDto,
  IPlanYearLiteDto,
  IPayoutDefinitionServiceDto,
  IPayoutDefinitionPlanDto,
  IIdNameDto,
  IEnumTypeDto,
  ICategorySummaryDto,
  ICategoryServiceDto,
  IFileImportResponse,
  IFileInfoDto,
  IPatchFileDto,
  IFileRecordDto,
  IFileErrorDto,
  IFileUrlDto,
  ICheckDetailsDto,
  ICheckDetailsUpdateDto,
  IMultipleRecordsDto,
  IProcessedReturnedChecksDto,
  IReturnedCheckDecisionsDto,
  IOcrDetailsDto,
  IOcrDetailsRequestDto,
  IFileUrlsResponseDto,
  ICopyFilesRequestDto,
  IPresignUrlResponse,
  IPresignUrlRequestDto,
  IDocumentFileUploadCompletionDto,
  IQrCodePresignUrlRequestDto,
  IDocumentFileUploadByQrCodeDto,
  IOneTimeLinkPresignUrlRequestDto,
  IDocumentFileUploadByLinkDto,
  IReceiptDto,
  IQrCodeDto,
  IDocumentQrCodeDto,
  IDocumentOneTimeLinkDto,
  IReceiptPatchDto,
  IVendorDto,
  IReturnedItemsDto,
  ILockboxClaimRepaymentDto,
  IReceiptDocumentFileDto,
  IOneTimeLinkResponseDto,
  ICardStatusDto,
  ICardVerifyDto,
  ICardReplaceDto,
  ILockReasonTypeDto,
  IStatusDto,
  IPlanResponseDto,
  INotionalDetailsResponseDto,
  IHsaDetailsResponseDto,
  INotionalOverviewResponseDto,
  IHsaOverviewResponseDto,
  IClaimDetailsResponseDto,
  INotionalPlanBalanceMonthlyBreakdownResponseDto,
  IHsaPlanBalanceMonthlyBreakdownResponseDto,
  IReportSchedulerUpdateDto,
  IReportSchedulerCreateDto,
  IUndeliverableMailMetricsResponseDto,
  IPlanEnrollmentMetricsResponseDto,
  IInvoiceReplenishmentMetricsResponseDto,
  IInvoicePlanLevelReplenishmentMetricsResponseDto,
  IFraudReviewRequiredMetricsResponseDto,
  IEmployerCalendarEventsResponseDto,
  IEmployeeMetricsResponseDto,
  IDelinquentClaimsMetricsResponseDto,
  IClaimsSubstantiationRateMetricsResponseDto,
  ICipInfoMetricsResponseDto,
  ICipConfigMetricsResponseDto,
  ITotalClaimSpendResponseDto,
  IPlanYearResponseDto,
  IUpdateProviderDto,
  IProcessClaimDto,
  IWaitingForFundsDto,
  IClaimInternalNoteResponseDto,
  IClaimInternalNoteUpdateDto,
  IClaimEscalationNoteRequestDto,
  IEmployeeChoiceDto,
  ICarrierDto,
  IRolloverTransferRequestDto,
  IClaimAppealRequestDto,
  IClaimAppealDocumentUploadResponseDto,
  IClaimAssignRequestDto,
  IClaimInternalNoteRequestDto,
  ICreateHsaWithdrawalClaimDto,
  ILetterOfMedicalNecessityPatchDto,
  ICarrierConfigDto,
  ICustomPageExpenseInfoDto,
  IExpenseStatisticsResponseDto,
  IClaimStatusTypeDto,
  IClaimApprovalStatusCodeDto,
  IClaimTransferCalculationsDto,
  IClaimActivitiesViewDto,
  IPayrollCalendarDto,
  IPayrollCalendarUpdateDto,
  IPayrollCalendarUpdatePartnerRequestDto,
  IScheduledContributionResponseDto,
  IScheduledContributionRequestDto,
  IRecordTaxYearChangeCreateDto,
  IPayrollGroupDto,
  IPayrollGroupRequestDto,
  IPayrollCalendarRequestDto,
  IPayrollCalendarPartnerRequestDto,
  IContributionSearchResponseInfoDto,
  IContributionRequestDto,
  IScheduledContributionUpdateDto,
  IPayrollGroupPatchRequestDto,
  IScheduledCalendarDto,
  IPayrollCalendarResponseDto,
  IPayrollCalendarReducedDto,
  IContributionAmountDetailsDto,
  IContributionResponseDto,
  IContributionRecordIdentifier,
  IContributionActivityRecordResponseDto,
  IRiskToleranceModelResponseDto,
  IQuestionnaireDto,
  ITradingAmountsDto,
  IAggregatedPnlMetricDto,
  IInvestorBaseDto,
  IPortfolioFundAssetDto,
  IExternalTemplateLiteDto,
  IEmailTemplateThemeDto,
  ICommunicationDto,
  IAppNotificationDto,
  ICensusRequestBatchDto,
  ICensusResultDto,
  ICreateTokenRequest,
  IAddVaultedAccountResponse,
  IAddVaultedAccountRequest,
  IAccountMaintUpdateResult,
  ITokenizeAccountRequest,
  IInterestRateTemplateDto,
  IPrefundReturnApproveDto,
  IEoyPlanReconciliationApproveDto,
  ITaxFormMailingCreateDto,
  ICreateExcessContributionFormDto,
  IExcessContributionFileResponseDto,
  ICipQuestionnaireAnswersRequestDto,
  ICipChallengeAnswerRequestDto,
  ICoveragePeriodDto,
  IEmployeePlanCodeDto,
  IClaimParticipantResponseDto,
  IClaimParticipantSearchDto,
  ILinkTokenResponseDto,
  IExchangeTokenRequestDto,
  IUpdateAccountVerificationStatusDto
} from './models';


/**
 * Branded type to carry path information for type inference
 */
export type TypedPath<P extends string> = string & { __path: P };

/**
 * Path type mappings for automatic inference
 */
export interface PathTypes {
  '/activities/accounts/{account-id}': {
    GET: { response: IAggregatedAccountActivityDto[] };
  };
  '/activities/claims/{claimId}': {
    GET: { response: IClaimActivityDetails };
  };
  '/activities/postings/{postingId}': {
    GET: { response: IBankingActivityDetails };
  };
  '/v2/activities/accounts/{account-id}': {
    GET: { response: IAggregatedAccountActivityDto[] };
  };
  '/card-purses': {
    GET: { response: ICardPurseDto[] };
    PATCH: { request: ICardPurseAccessUpdateDto; response: ICardPurseAccountDto[] };
  };
  '/carrier-configs': {
    GET: { response: ICarrierConfigResponseAggregatorDtoPage };
    POST: { request: ICreateCarrierConfigAggregatorDto; response: ICarrierConfigResponseAggregatorDto };
  };
  '/checks/search': {
    GET: { response: IChecksResponseAggregatorDtoPage };
  };
  '/checks/{check-id}/reissue': {
    PUT: { request: ICheckReissueDto };
  };
  '/checks/{check-id}/void': {
    PUT: { request: ICheckVoidDto };
  };
  '/idology/identification': {
    POST: { response: ICipIdologyResponseDto };
  };
  '/claims': {
    POST: { request: ICreateClaimAggregatorDto; response: IClaimInfoResponseDto };
  };
  '/claims/payment-details': {
    GET: { response: IPaymentDetailsResponseDto };
  };
  '/claims/repayment/matches': {
    GET: { response: IClaimRepaymentAggregatedDto };
  };
  '/claims/retry-payment': {
    POST: { request: IRetryClaimPaymentDto };
  };
  '/claims/search': {
    GET: { response: IClaimsResponseAggregatorDtoPage };
    POST: { request: IClaimSearchDto; response: IPageClaimDto };
  };
  '/claims/{claim-id}': {
    GET: { response: IClaimInfoAggregatorResponseDto };
    PATCH: { request: IManualClaimUpdateDto; response: IClaimInfoResponseDto };
  };
  '/claims/{claim-id}/document': {
    PUT: { request: IDocumentIdDto; response: IClaimInfoResponseDto };
  };
  '/claims/{claim-id}/documents/one-time-links/{hash-id}': {
    PUT: { response: IPrivateClaimInfoResponseDto };
  };
  '/claims/{claim-id}/rejected-claim': {
    GET: { response: IClaimRejectedAggregatorDto };
  };
  '/claims/{claim-id}/related-card-swipes': {
    GET: { response: IRelatedClaimEnhancedDto[] };
  };
  '/claims/{claim-id}/start-repayment': {
    POST: { request: IClaimRepaymentStartDto };
  };
  '/monitor-contribution/info': {
    GET: { response: IMonitorContributionAggregateResponseDto };
  };
  '/recurring-contributions': {
    GET: { response: IRecurringContributionResponseDto };
    PUT: { request: IRecurringContributionAggregatorRequestDto; response: IRecurringContributionAggregateResponseDto };
  };
  '/recurring-contributions/info': {
    GET: { response: IRecurringContributionAggregateResponseDto };
  };
  '/recurring-contributions/{id}': {
    PATCH: { request: IRecurringContributionPatchUpdateRequestDto; response: IRecurringContributionResponseDto };
  };
  '/contribution-requests': {
    GET: { response: IContributionRequestInfoAggregateDto };
  };
  '/contribution-requests/irs-limits': {
    GET: { response: IEmployeeContributionLimitResponse[] };
  };
  '/manual-contribution': {
    POST: { request: IAggregatorManualContributionRequestDto; response: IContributionSegmentResponseDto[] };
  };
  '/contributions/contribution-requests/employee': {
    POST: { request: IEeContributionRequestDto; response: IEeContributionResponseDto };
  };
  '/payment-methods/debit-card': {
    POST: { request: ICreateDebitCardRequest; response: IPaymentMethodResponseDto };
  };
  '/dependents': {
    POST: { request: IDependentInfoDto; response: IDependentInfoDto };
  };
  '/dependents/{dependent-id}': {
    GET: { response: IDependentInfoDto };
    PUT: { request: IDependentInfoDto; response: IDependentInfoDto };
  };
  '/v2/dependents': {
    POST: { request: IDependentRequestDto; response: IDependentResponseDto };
  };
  '/v2/dependents/{dependent-id}': {
    GET: { response: IDependentResponseDto };
    PUT: { request: IDependentUpdateDto; response: IDependentResponseDto };
  };
  '/documents': {
    GET: { response: IDocumentFilesUrlDto };
    POST: { request: ICreateDocumentAggregatorDto; response: IDocumentIdDto };
  };
  '/employees/linked-accounts': {
    GET: { response: IAggregatedEmployeeLinkedAccountsDto[] };
  };
  '/employees/balance-reminder': {
    GET: { response: IBalanceReminderResponseDto };
  };
  '/employees/matches': {
    GET: { response: IEmployeeMatchDetailsAggregatorDto };
  };
  '/employees/{employee-id}/bad-data': {
    POST: { request: IEmployeeBadRecordRequestDto };
  };
  '/enrollments': {
    GET: { response: IEnrollmentDto[] };
  };
  '/express-setups': {
    POST: { response: IExpressSetupDto };
  };
  '/express-setups/{organization-id}': {
    GET: { response: IExpressSetupExtendedDto };
    PATCH: { response: IExpressSetupDto };
  };
  '/express-setups/{organization-id}/status': {
    PATCH: { response: IExpressSetupDto };
  };
  '/files/file-actors': {
    GET: { response: IFileActorDto[] };
  };
  '/file/files/{file-id}/records/errors': {
    GET: { response: IFileRecordErrorAggregatorDto };
  };
  '/file/files': {
    POST: { request: ISearchFileDto };
  };
  '/file/files/{file-id}/details': {
    GET: { response: IFileDetailsAggregatorResponseDto };
  };
  '/health-plans': {
    GET: { response: IHealthPlanBaseDto[] };
    POST: { request: IHealthPlanCreateDto; response: IHealthPlanDto };
  };
  '/health-plans/{health-plan-id}': {
    PUT: { request: IHealthPlanUpdateDto; response: IHealthPlanDto };
  };
  '/investments/flows/funding': {
    PATCH: { request: IFundingPatchDto; response: IInvestorDto };
  };
  '/investments/flows/path': {
    PATCH: { request: IInvestmentOperationRequestDto; response: IInvestorDto };
  };
  '/investments/flows/start': {
    POST: { response: IInvestorDto };
  };
  '/investments/holdings': {
    GET: { response: IInvestmentHoldingsDto };
  };
  '/investors/investment-models': {
    PATCH: { request: IInvestmentModelSwitchDto; response: IInvestorDto };
  };
  '/investment-schedulers': {
    GET: { response: IAutoInvestmentSchedulerResponseDto };
    PUT: { request: IAutoInvestmentSchedulerUpdateDto; response: IAutoInvestmentSchedulerResponseDto };
    POST: { request: IAutoInvestmentSchedulerRequestDto; response: IAutoInvestmentSchedulerResponseDto };
  };
  '/trades': {
    POST: { request: ITradeCreateDto };
  };
  '/invoices/dashboard': {
    GET: { response: IInvoiceDashboardPageDto };
  };
  '/invoices/{invoice-id}/details-view': {
    GET: { response: IInvoiceDetailsAggregatorDto };
  };
  '/lockboxes/matched-employees/{employee-id}': {
    GET: { response: ILockboxDetailsAggregatorDto };
  };
  '/lockboxes/{lockbox-id}': {
    GET: { response: ILockboxDetailsAggregatorDto };
    PATCH: { request: IUpdateLockboxAggregatorDto; response: ILockboxDto };
  };
  '/coverages': {
    GET: { response: ICoverageDto[] };
    POST: { request: ICoverageDto; response: ICoverageDto };
  };
  '/enrollment-matrixes': {
    POST: { request: IEnrollmentMatrixDto; response: IEnrollmentMatrixDto };
  };
  '/organization-locks/lock/{organization-id}': {
    POST: { response: IOrganizationLockDto };
  };
  '/organization-locks/unlock/{organization-id}': {
    PATCH: { response: IOrganizationLockDto };
  };
  '/organizations': {
    GET: { response: IOrganizationExpressSetupResponseDto };
    POST: { request: IOrganizationInfoDto; response: IOrganizationInfoDto };
  };
  '/organizations/overridable-properties/by-one-time-links/{hash-id}': {
    GET: { response: IQrCodeOverridablePropertiesDto };
  };
  '/organizations/overridable-properties/by-qr-codes/{qr-id}': {
    GET: { response: IQrCodeOverridablePropertiesDto };
  };
  '/ui/organizations/{organization-id}/termination': {
    PUT: { request: IEmployerTerminationPropertiesCreateDto; response: IEmployerTerminationPropertiesDto };
  };
  '/payment-account': {
    POST: { request: IPaymentAccountRequestDto; response: IPaymentAccountResponseDto };
  };
  '/payment-methods': {
    GET: { response: IPaymentMethodSetupResponseDto[] };
    POST: { request: IPaymentMethodSetupRequestDto; response: IPaymentMethodSetupResponseDto };
  };
  '/payment-methods/{id}': {
    GET: { response: IPaymentMethodResponseDto };
    PUT: { response: IPaymentMethodResponseDto };
    PATCH: { request: IUpdatePaymentMethodRequestDto; response: IPaymentMethodSetupResponseDto };
  };
  '/payment-methods/{id}/card': {
    POST: { request: IFiservCardVaultToken; response: IPaymentMethodSetupResponseDto };
  };
  '/prefund-histories/invoices/{invoice-id}/summary': {
    GET: { response: IPrefundSummaryDto };
  };
  '/processing-rules': {
    POST: { request: IProcessingRuleDto; response: IProcessingRuleDto };
  };
  '/providers': {
    GET: { response: IProviderInfoDto[] };
    POST: { request: ICreateProviderAggregatorDto; response: IProviderInfoDto };
  };
  '/signup': {
    POST: { request: ISignUpRequestDto };
  };
  '/transfer/claims/{claim-id}': {
    POST: { request: IClaimTransferCreateBatchDto };
  };
  '/transfer/employees/{employee-id}/accounts': {
    GET: { response: IClaimTransferAccountDto[] };
  };
  '/documents/files/by-link/{file-id}/openai/ocr/matching': {
    GET: { response: IOcrClaimDto };
  };
  '/documents/files/{file-id}/ocr-reader': {
    GET: { response: IOcrClaimDto };
  };
  '/documents/files/{file-id}/openai/ocr/matching': {
    GET: { response: IOcrClaimDto };
    PATCH: { request: IOcrDto; response: IOcrReceiptResponseDto };
  };
  '/service-configs/{id}': {
    PUT: { request: IServiceConfigDto; response: IServiceConfigDto };
  };
  '/processing-rules/{id}': {
    PUT: { request: IProcessingRuleDto };
    PATCH: { request: IUpdateProcessingRuleTiersDto };
  };
  '/plan-account-funding-config/plan-level-funding': {
    PUT: { request: IPlanIdsDto; response: IFundingLevelSwitchingDto[] };
  };
  '/health-plans/{id}': {
    GET: { response: IHealthPlanDto[] };
  };
  '/deductibles/employees/{employee-id}': {
    PUT: { request: IDeductibleUpdateRequestDto };
  };
  '/triggers': {
    POST: { request: ITriggerDto; response: ITriggerDto };
  };
  '/service-configs': {
    GET: { response: IServiceConfigDto[] };
    POST: { request: IServiceConfigDto; response: IServiceConfigDto };
  };
  '/plans/termination-properties': {
    POST: { request: IPlanTerminationPropertiesDto };
  };
  '/deductibles/employees/{employee-id}/preview': {
    POST: { request: IDeductiblePreviewRequestDto };
  };
  '/processing-rules/{id}/payout-rules': {
    PATCH: { request: IUpdatePayoutRuleTypeRequestDto };
  };
  '/plans/{plan-id}/termination-properties': {
    PATCH: { request: IPlanTerminationPropertiesPatchDto };
  };
  '/enrollment-matrixes/{id}': {
    PATCH: { request: IEnrollmentMatrixPatchDto; response: IEnrollmentMatrixDto };
  };
  '/v2/services/all': {
    GET: { response: IServiceDto[] };
  };
  '/tiers/deductibles': {
    GET: { response: IDeductibleTierDto };
  };
  '/spend-limit-periods/{account-id}': {
    GET: { response: ISpendLimitPeriodDto };
  };
  '/spend-limit-periods/{account-id}/remaining': {
    GET: { response: ISpendLimitPeriodRemainingDto };
  };
  '/spend-limit-periods/remaining': {
    GET: { response: ISpendLimitRemainingByAccountDto };
  };
  '/person-spend-limits': {
    GET: { response: IPersonSpendLimitDto[] };
  };
  '/organization-locks/{organizationId}': {
    GET: { response: IOrganizationLockDto };
  };
  '/mp-tables': {
    GET: { response: IMpTableDto[] };
  };
  '/irs-maximums': {
    GET: { response: IIrsLimitDto[] };
  };
  '/irs-maximums/types': {
    GET: { response: IIrsLimitLiteDto[] };
  };
  '/irs-maximums/employee/{employee-id}': {
    GET: { response: IPolicyLimitsDto };
  };
  '/health-plans/templates': {
    GET: { response: IHealthPlanBaseDto[] };
  };
  '/health-plans/health-policies': {
    GET: { response: IHealthPolicyDto[] };
  };
  '/enrollment-matrixes/closest': {
    GET: { response: IEnrollmentMatrixDto };
  };
  '/cov-tables': {
    GET: { response: ICovTableDto[] };
  };
  '/category-spend-limits': {
    GET: { response: ICategorySpendLimitDto[] };
  };
  '/account-orders': {
    GET: { response: IAccountOrderDto };
  };
  '/account-orders/services': {
    GET: { response: IAccountOrderMatrixDto };
  };
  '/ui/employees/{employee-id}/extended': {
    GET: { response: IEmployeeMatchDetailsAggregatorDto };
  };
  '/plan-years': {
    GET: { response: IPlanYearDto[] };
    POST: { request: IPlanYearDto; response: IPlanYearDto };
  };
  '/plan-years/{plan-year-id}': {
    PUT: { request: IPlanYearDto; response: IPlanYearDto };
  };
  '/sequences': {
    GET: { response: ISequenceDto[] };
    POST: { request: ISequenceDto; response: ISequenceDto };
  };
  '/ui/payroll-calendars/organizations/{organization-id}': {
    GET: { response: IPayrollCalendarAggregatorResponseDto[] };
  };
  '/ui/payroll-calendars/{id}': {
    GET: { response: IPayrollCalendarExtendedAggregatorResponseDto };
  };
  '/plans': {
    POST: { request: IPlanDto; response: IPlanDto };
  };
  '/plans/{plan-id}': {
    GET: { response: IPlanDto };
    PUT: { request: IPlanDto; response: IPlanDto };
  };
  '/templates/organizations/{organization-id}/linked-templates': {
    PATCH: { request: IPatchLinkedSystemTemplatesDto };
  };
  '/renewals': {
    GET: { response: IRenewalRecordExtendedDto[] };
  };
  '/renewals/plan-year/{plan-year-id}': {
    GET: { response: IRenewalRecordExtendedDto };
    PATCH: { response: IRenewalRecordDto };
  };
  '/ui/employees': {
    POST: { request: IEmployeeInfoCreateAggregatorDto; response: IEmployeeInfoResponseDto };
    PATCH: { request: IEmployeeInfoPatchDto; response: IEmployeeInfoPatchDto };
  };
  '/ui/employees/{employee-id}': {
    PUT: { request: IEmployeeInfoUpdateDto; response: IEmployeeInfoResponseDto };
    PATCH: { request: IEmployeeInfoAdminPatchDto };
  };
  '/organizations/{organization-id}/termination': {
    GET: { response: IEmployerTerminationPropertiesDto };
    PUT: { request: IEmployerTerminationPropertiesV3Dto; response: IEmployerTerminationPropertiesDto };
    POST: { request: IEmployerTerminationPropertiesV3Dto; response: IEmployerTerminationPropertiesDto };
  };
  '/contributions/contribution-requests/{request_id}/contribution-records': {
    PUT: { request: IContributionRecordUpdateRequestDto[] };
  };
  '/contribution-requests/irs-limits/search': {
    POST: { request: IIrsLimitsSearchRequest; response: IEmployeeContributionLimitResponse[] };
  };
  '/card/{card_id}/provision': {
    POST: { request: IPushProvisionRequest; response: IPushProvisionResponse };
  };
  '/push-provision/email-validation': {
    PATCH: { request: IPushProvisionEmailVerificationRequest; response: IPushProvisionResponse };
  };
  '/contributions/contribution-requests/{request_id}/contribution-records/update-all': {
    PATCH: { request: IContributionRecordBulkUpdateRequestDto };
  };
  '/unmatched-push-transactions/total-balance': {
    GET: { response: IUnmatchedPushTotalBalanceResponse };
  };
  '/contribution-requests/records/tax-years': {
    GET: { response: IContributionRecordAvailableTaxYearsResponseDto };
  };
  '/contribution-requests/records/tax-years-change': {
    GET: { response: IRecordTaxYearChangeResponseDto };
  };
  '/card/{card_id}/wallets': {
    GET: { response: IGetWalletDataResponse };
  };
  '/card-holders': {
    GET: { response: ICardHolderWithDependentDto };
  };
  '/activities/postings/{postingId}/payment-details': {
    GET: { response: IPaymentDetailsResponseDto };
  };
  '/letters-of-medical-necessity': {
    POST: { request: ILetterOfMedicalNecessityCreateDto; response: ILetterOfMedicalNecessityDto };
  };
  '/transactions/manual-transactions': {
    POST: { request: ICreateTransactionWorkflowDto };
  };
  '/postings/account/amount': {
    POST: { request: ICalculationAccountAmountRequestDto; response: ICalculationAccountAmountResponseDto[] };
  };
  '/fee/transfer': {
    POST: { request: IFeeTransferCreateDto };
  };
  '/fee/reversal': {
    POST: { request: IFeeReversalCreateDto };
  };
  '/balance-adjustment': {
    POST: { request: IBalanceAdjustmentRequestDto };
  };
  '/plan-omni-balances/history': {
    GET: { response: IPlanOmniBalanceHistoryDto[] };
  };
  '/organizations/{organization-id}/accounts': {
    GET: { response: ICustomPageEncryptedAccountDto };
  };
  '/enums/account-types': {
    GET: { response: IAccountTypeDto[] };
  };
  '/enums/account-categories': {
    GET: { response: IAccountCategoryDto[] };
  };
  '/encryption/public-key': {
    GET: { response: IPublicKeyDto };
  };
  '/accounts/{id}': {
    GET: { response: IEncryptedAccountDto };
    PUT: { request: IUpdateEncryptedExternalBankAccountDto; response: IEncryptedAccountDto };
  };
  '/accounts': {
    GET: { response: ICustomPageEncryptedAccountDto };
    POST: { request: ICreateEncryptedExternalBankAccountDto; response: IEncryptedAccountDto };
  };
  '/accounts/close': {
    POST: { request: IAccountCloseMessage };
  };
  '/accounts/calculate-total-balance': {
    POST: { request: ICalculateTotalBalanceRequestDto; response: ICalculateTotalBalanceResponseDto };
  };
  '/accounts/verification': {
    GET: { response: IAccountVerificationStatusResponseDto[] };
  };
  '/accounts/matches': {
    GET: { response: ICustomPageAccountDto };
  };
  '/accounts/hsa': {
    GET: { response: IAccountDto[] };
  };
  '/accounts/hsa/{account-id}/number': {
    GET: { response: IAccountNumberDto };
  };
  '/accounts/closure-amounts': {
    GET: { response: IAccountClosureAmountsDto };
  };
  '/accounts/batch': {
    GET: { response: IEncryptedAccountDto[] };
  };
  '/persons/{person-id}': {
    GET: { response: IPersonInfoDto };
  };
  '/employees/{employee-id}/sso-signup': {
    PUT: { request: ISsoUserSignUpDto; response: IPublicEmployeeInfoDto };
  };
  '/employees/{employee-id}/fraud-review': {
    PUT: { request: IFraudReviewRequestDto };
  };
  '/employees/{employee-id}/beneficiaries': {
    PUT: { request: IBeneficiaryUpdateDto[] };
    POST: { request: IBeneficiaryUpdateDto[] };
  };
  '/authorized-users/{id}': {
    PUT: { request: IUpdateAuthorizedUserDto };
  };
  '/registration/verification': {
    POST: { request: IPersonRegistrationVerifyRequestDto; response: IPersonRegistrationVerifyResponseDto };
  };
  '/registration/usernames/verification': {
    POST: { request: IUsernameRegistrationVerifyRequestDto };
  };
  '/persons/usernames/forgot': {
    POST: { request: IForgotUsernameRequestDto };
  };
  '/mobile-app/problem-report': {
    POST: { request: IMobileAppProblemReportRequestDto };
  };
  '/mobile-app/feedback': {
    POST: { request: IMobileAppFeedbackRequestDto };
  };
  '/combine-hsa/file-upload': {
    POST: { response: ICombineHsaFileResponseDto };
  };
  '/codes/verifications': {
    POST: { request: IVerificationCodeRequestCreateDto; response: IVerificationCodeRequestCreateDto };
  };
  '/authorized-users': {
    POST: { request: ICreateAuthorizedUserDto };
  };
  '/employees/{employee-id}/link': {
    GET: { response: IEmployeeLinkResponseDto };
    PATCH: { response: IEmployeeLinkResponseDto };
  };
  '/employees/{employee-id}/claim-config': {
    PATCH: { request: IEmployeeAutopayPropertiesDto; response: IEmployeeAutopayPropertiesDto };
  };
  '/emails/confirmation': {
    PATCH: { request: ILinkVerificationCodeValidationRequestDto; response: IVerificationCodeValidationResponseDto };
  };
  '/codes/verifications/validation': {
    PATCH: { request: IVerificationCodeValidationRequestDto; response: IVerificationCodeValidationResponseDto };
  };
  '/v2/dependents/names': {
    GET: { response: IDependentNameDto[] };
  };
  '/v2/dependents/employee/{employee-id}': {
    GET: { response: IDependentResponseDto };
  };
  '/ui/employees/{employee-id}/ssn': {
    GET: { response: ISsnInfoDto };
  };
  '/mobile-app/feedback/config': {
    GET: { response: IMobileAppFeedbackReminderResponseDto };
  };
  '/enums/beneficiary-relationship-types': {
    GET: { response: IEnumInfoDto[] };
  };
  '/employees/{employee-id}': {
    GET: { response: IPublicEmployeeInfoDto };
  };
  '/employees/{employee-id}/internal': {
    GET: { response: IPublicEmployeeInfoDto };
  };
  '/employees/{employee-id}/employee-view': {
    GET: { response: IEmployeeViewDto };
  };
  '/employees/search': {
    GET: { response: IPublicEmployeeInfoDto };
  };
  '/employees/personal-info/{employee-id}': {
    GET: { response: IEmployeePersonalInfoDto };
  };
  '/employees/names': {
    GET: { response: IEmployeeNameDto[] };
  };
  '/employees/linkage-search': {
    GET: { response: ILinkedEmployeeInfoDto };
  };
  '/employees/admin/search': {
    GET: { response: ICustomPageEmployeeEmployerInfoDto };
  };
  '/dependents/names': {
    GET: { response: IDependentNameDto[] };
  };
  '/dependents/employee/{employee-id}': {
    GET: { response: IDependentInfoDto };
  };
  '/employees/{employee-id}/account/{account-id}/combine-with-hsa': {
    POST: { request: ICombineHsaRequestDto };
  };
  '/roles/{id}': {
    PUT: { request: IRoleUpdateDto };
  };
  '/organization-properties-state-configs/{id}': {
    PUT: { request: IOrganizationPropertiesStateConfigRequestDto };
  };
  '/application-users/role': {
    PUT: { request: IEmployeeRoleUpdateDto };
  };
  '/zendesk/messaging-token': {
    POST: { response: IZendeskMessagingTokenResponseDto };
  };
  '/signin': {
    POST: { request: IInitiateAuthRequestDto; response: IInitiateAuthResponseDto };
  };
  '/roles': {
    POST: { request: IRoleCreateDto };
  };
  '/revoke': {
    POST: { request: IRevokeTokenRequestDto };
  };
  '/resend-confirmation-code': {
    POST: { request: IResendConfirmationCodeRequestDto };
  };
  '/refresh': {
    POST: { request: ITokenRequestDto; response: ITokenResponseDto };
  };
  '/persons/forgot-password': {
    POST: { request: IForgotPasswordRequestDto };
  };
  '/passwords': {
    POST: { request: IUserChangePasswordDto };
  };
  '/passwords/reset': {
    POST: { request: IUserConfirmForgotPasswordDto };
  };
  '/organization-properties-state-configs': {
    POST: { request: IOrganizationPropertiesStateConfigRequestDto };
  };
  '/oauth2/token': {
    POST: { request: ICodeExchangeRequestDto };
  };
  '/mfa/unlock': {
    POST: { request: IUnlockMfaDto };
  };
  '/mfa/codes': {
    POST: { request: IChannelRequestDto };
  };
  '/mfa/codes/verifications': {
    POST: { request: ICodeRequestDto; response: IInitiateAuthResponseDto };
  };
  '/login/unlock': {
    POST: { request: IChangeUserLockingRequest };
  };
  '/login/lock': {
    POST: { request: IChangeUserLockingRequest };
  };
  '/forgot-password': {
    POST: { request: IForgotPasswordRequestDto };
  };
  '/contacts/usernames/forgot': {
    POST: { request: IForgotUsernameRequestDto };
  };
  '/contacts/signin': {
    POST: { request: IInitiateAuthRequestDto; response: IInitiateAuthResponseDto };
  };
  '/contacts/refresh': {
    POST: { request: ITokenRequestDto; response: ITokenResponseDto };
  };
  '/contacts/mfa/codes': {
    POST: { request: IChannelRequestDto };
  };
  '/contacts/mfa/codes/verifications': {
    POST: { request: ICodeRequestDto; response: IInitiateAuthResponseDto };
  };
  '/contacts/codes': {
    POST: { request: IChannelRequestDto };
  };
  '/contacts/codes/verifications': {
    POST: { request: ICodeRequestDto; response: IInitiateAuthResponseDto };
  };
  '/app-clients': {
    GET: { response: IAppClientInfoDto };
    POST: { request: IAppClientInfoDto; response: IAppClientInfoDto };
  };
  '/sign-up/confirmation': {
    PATCH: { request: IConfirmSignUpRequestDto; response: IConfirmSignUpRequestDto };
  };
  '/password/reset/validation': {
    GET: { response: IPasswordResetLinkValidationResponseDto };
  };
  '/organization-properties-states': {
    GET: { response: IOrganizationPropertiesStatesDto };
  };
  '/contacts/{contact-id}': {
    GET: { response: IContactInfoDto[] };
    PUT: { request: IContactSaveDto; response: IContactInfoDto };
  };
  '/contacts/{contact-id}/claims-teams': {
    GET: { response: IClaimsTeamInfoDto };
    PUT: { request: IContactSaveClaimsTeamsDto };
  };
  '/claims-teams/{claims-team-id}': {
    GET: { response: IClaimsTeamInfoDto };
    PUT: { request: IClaimsTeamUpdateDto; response: IClaimsTeamInfoDto };
  };
  '/claims-teams/{claims-team-id}/contacts': {
    PUT: { request: IClaimsTeamSaveContactDto };
  };
  '/express-setup/contacts': {
    POST: { request: IExpressContactSaveDto; response: IContactInfoDto };
  };
  '/contacts': {
    GET: { response: IContactDataDto };
    POST: { request: IContactSaveDto; response: IContactInfoDto };
  };
  '/contacts/verification-codes': {
    POST: { request: IVerificationCodeRequestCreateDto };
  };
  '/contacts/teams': {
    POST: { request: IContactByClaimsTeamsDto; response: ICustomPageContactInfoDto };
  };
  '/claims-teams': {
    GET: { response: IClaimsTeamInfoDto };
    POST: { request: IClaimsTeamCreateDto; response: IClaimsTeamInfoDto };
  };
  '/claims-teams/search': {
    POST: { response: IClaimsTeamInfoDto };
  };
  '/claims-teams/search-assigned': {
    POST: { request: IClaimsTeamCreateDto; response: IClaimsTeamInfoDto };
  };
  '/contacts/{contact-id}/express': {
    PATCH: { request: IExpressContactStatusDto; response: IContactInfoDto };
  };
  '/contacts/email/verifications': {
    PATCH: { request: ILinkVerificationCodeValidationRequestDto; response: IVerificationCodeValidationResponseDto };
  };
  '/organization-properties/hash/{hash-id}': {
    GET: { response: IHashIdOverridablePropertiesDto };
  };
  '/mobile-themes': {
    GET: { response: IMobileAppThemeDto[] };
  };
  '/express-setup/enabled': {
    GET: { response: IExpressSetupInfoDto };
  };
  '/enums/source-ids': {
    GET: { response: IIdSourceTypeDto[] };
  };
  '/enums/relationship-types': {
    GET: { response: IRelationshipTypeDto };
  };
  '/enums/hsa-custodians': {
    GET: { response: IHsaCustodianTypeDto[] };
  };
  '/enums/eligible-dependents': {
    GET: { response: IEligibleDependentsDto };
  };
  '/enums/electronic-funding-replenishments': {
    GET: { response: IElectronicFundingDto };
  };
  '/enums/check-writings': {
    GET: { response: ICheckWritingTypeDto };
  };
  '/enums/business-entity-types': {
    GET: { response: IBusinessEntityTypeDto[] };
  };
  '/enums/bank-methods': {
    GET: { response: IBankMethodsDto };
  };
  '/contacts/up-hierarchy': {
    GET: { response: ICustomPageContactInfoDto };
  };
  '/contacts/count-by-role': {
    GET: { response: IContactCountDto[] };
  };
  '/contacts/appeal-eligible': {
    GET: { response: IContactInfoDto[] };
  };
  '/contacts/all': {
    GET: { response: ICustomPageContactInfoDto };
  };
  '/contacts/all/lite': {
    GET: { response: IContactInfoLiteDto[] };
  };
  '/organizations/{organization-id}': {
    GET: { response: IOrganizationInfoDto };
    PUT: { request: IOrganizationInfoDto };
  };
  '/organizations/{organization-id}/properties': {
    GET: { response: IOrganizationPropertyInfoDto };
    PUT: { request: IOrganizationPropertyInfoDto; response: IOrganizationPropertyInfoDto };
    POST: { request: IOrganizationPropertyInfoDto; response: IOrganizationPropertyInfoDto };
  };
  '/organizations/{organization-id}/overridable-properties': {
    GET: { response: IOverridablePropertiesInfoDto };
    PUT: { request: IOverridablePropertiesInfoDto };
  };
  '/organizations/{organization-id}/addresses/{address-id}': {
    GET: { response: IPreferredDto };
    PUT: { request: IPreferredDto };
    POST: { request: IPreferredDto; response: IPreferredDto };
  };
  '/organizations/{organization-id}/reactivation': {
    POST: { request: IOrganizationReactivationRequest };
  };
  '/organizations/{organization-id}/phones': {
    GET: { response: IOrganizationPhoneInfoDto };
    POST: { request: IOrganizationPhoneInfoDto; response: IOrganizationPhoneInfoDto };
  };
  '/organizations/{organization-id}/overridable-properties/validate': {
    POST: { request: IOverridablePropertiesInfoDto; response: IOverridablePropertiesValidateDto };
  };
  '/organizations/{organization-id}/overridable-properties/propagate': {
    POST: { request: IPropagateOverridablePropertiesRequest; response: IPropagateOverridablePropertiesResponse };
  };
  '/organizations/short': {
    POST: { request: ISearchOrganizationDto; response: ICustomPageOrganizationShortDto };
  };
  '/organizations/logo': {
    POST: { response: IOrganizationLogoDto };
  };
  '/organizations/logo/email-templates': {
    POST: { response: IOrganizationEmailTemplateLogoDto };
  };
  '/organizations/{organization-id}/notification-properties': {
    PATCH: { request: INotificationPropertiesInfoDto };
  };
  '/organizations/{organization-id}/phones/{phone-id}': {
    GET: { response: IOrganizationPhoneInfoDto };
  };
  '/organizations/{organization-id}/overridable-properties/employee': {
    GET: { response: IEmployeeOverridablePropertiesInfoDto };
  };
  '/organizations/{organization-id}/notes': {
    GET: { response: IOrganizationNoteDto };
  };
  '/organizations/{organization-id}/employee-view': {
    GET: { response: IOrganizationViewDto };
  };
  '/organizations/{id}/short': {
    GET: { response: IOrganizationShortDto };
  };
  '/organizations/{id}/name': {
    GET: { response: IOrganizationNameDto[] };
  };
  '/organizations/orphan': {
    GET: { response: IOrganizationShortDto[] };
  };
  '/organizations/names': {
    GET: { response: IOrganizationNameDto[] };
  };
  '/organizations/hierarchy': {
    GET: { response: IHierarchyNode };
  };
  '/organizations/external-id/{external-id}': {
    GET: { response: IOrganizationLiteDto };
  };
  '/organizations/claims-team/{claims-team-id}/hierarchy': {
    GET: { response: IHierarchyNode };
  };
  '/organizations/account-manager/{account-manager-id}': {
    GET: { response: IOrganizationNameDto[] };
  };
  '/invoices/apply-unmatched': {
    POST: { request: IApplyUnmatchedInvoicesRequestDto };
  };
  '/transactors/{transactor-id}': {
    GET: { response: ITransactorInfoDto };
  };
  '/invoices/search-unapplied-push': {
    GET: { response: IPageUnappliedPushInvoiceDto };
  };
  '/enums/states': {
    GET: { response: IStateInfoDto[] };
  };
  '/enums/countries': {
    GET: { response: ICountryInfoDto[] };
  };
  '/sequences/{id}': {
    GET: { response: ISequenceDto };
    PUT: { request: ISequenceDto; response: ISequenceDto };
  };
  '/plan-years/{id}': {
    GET: { response: IPlanYearDto };
  };
  '/payout-definitions/{id}': {
    GET: { response: IPayoutDefinitionDto };
    PUT: { request: IPayoutDefinitionUpdateDto; response: IPayoutDefinitionDto };
  };
  '/copay-groups/{id}': {
    GET: { response: ICopayGroupDto };
    PUT: { request: ICopayGroupDto; response: ICopayGroupDto };
  };
  '/services': {
    GET: { response: IServiceDto[] };
    POST: { request: IServiceCreateDto; response: IServiceDto };
  };
  '/plans/reactivation': {
    POST: { request: IPlanReactivationDto };
  };
  '/plans/plan-codes/validations': {
    POST: { request: IPlanCodeValidationRequestDto; response: IPlanCodeValidationResponseDto[] };
  };
  '/payout-definitions': {
    POST: { request: IPayoutDefinitionCreateDto; response: IPayoutDefinitionDto };
  };
  '/copay-groups': {
    POST: { request: ICopayGroupDto; response: ICopayGroupDto };
  };
  '/services/{id}': {
    GET: { response: IServiceDto };
    PATCH: { request: IServiceUpdateRequest; response: IServiceDto };
  };
  '/templates': {
    GET: { response: IPlanTemplateConfigDto };
  };
  '/policies': {
    GET: { response: IPolicyEnrollmentDto[] };
  };
  '/policies/{policyId}/policy-statuses': {
    GET: { response: IPolicyStatusDto[] };
  };
  '/policies/{policy-id}/statuses/{status-id}': {
    GET: { response: IPolicyStatusDto };
  };
  '/policies/{policy-id}/limits': {
    GET: { response: IPolicySpendLimitsDto };
  };
  '/policies/{policy-id}/elections/{election-id}': {
    GET: { response: IPolicyElectionDto };
  };
  '/plans/{plan-id}/health-plan-tier-stats': {
    GET: { response: IHealthPlanTierStatsDto[] };
  };
  '/plans/{plan-id}/active-grace-period': {
    GET: { response: IPlanGracePeriodDto };
  };
  '/plans/priors': {
    GET: { response: IPriorPlanDto[] };
  };
  '/plans/plan-primary-config': {
    GET: { response: IPlanPrimaryConfigLiteDto };
  };
  '/plans/organizations/{organization-id}/reactivation-eligible': {
    GET: { response: IPlanDto[] };
  };
  '/plans/organizations/{organization-id}/active-grace-period': {
    GET: { response: IPlanGracePeriodDto[] };
  };
  '/plans/accounts': {
    GET: { response: IPlanDto };
  };
  '/plan-years/{id}/plans': {
    GET: { response: IPlanYearPlanDto };
  };
  '/plan-years/priors': {
    GET: { response: IPlanYearDto[] };
  };
  '/plan-years/list': {
    GET: { response: IPlanYearDto[] };
  };
  '/plan-years/health-plans': {
    GET: { response: IPlanYearLiteDto[] };
  };
  '/payout-definitions/{id}/services': {
    GET: { response: IPayoutDefinitionServiceDto[] };
  };
  '/payout-definitions/{id}/plans': {
    GET: { response: IPayoutDefinitionPlanDto[] };
  };
  '/payout-definitions/lite': {
    GET: { response: IIdNameDto[] };
  };
  '/enums/triggers': {
    GET: { response: IEnumTypeDto[] };
  };
  '/enums/service-categories': {
    GET: { response: IEnumTypeDto[] };
  };
  '/enums/proof-of-expenses': {
    GET: { response: IEnumTypeDto[] };
  };
  '/enums/payout-rules': {
    GET: { response: IEnumTypeDto[] };
  };
  '/enums/frequencies': {
    GET: { response: IEnumTypeDto[] };
  };
  '/categories': {
    GET: { response: ICategorySummaryDto[] };
  };
  '/categories/services': {
    GET: { response: ICategoryServiceDto[] };
  };
  '/files/csv/import': {
    POST: { response: IFileImportResponse };
  };
  '/file/files/{file-id}': {
    PATCH: { request: IPatchFileDto; response: IFileInfoDto };
  };
  '/file/cancel/{file-id}': {
    PATCH: { response: IFileInfoDto };
  };
  '/file/approve/{file-id}': {
    PATCH: { response: IFileInfoDto };
  };
  '/file/{file-id}': {
    GET: { response: IFileInfoDto };
  };
  '/file/files/{file-id}/records': {
    GET: { response: IFileRecordDto };
  };
  '/file/files/{file-id}/errors': {
    GET: { response: IFileErrorDto };
  };
  '/file/file-link/{file-id}': {
    GET: { response: IFileUrlDto };
  };
  '/lockboxes/{lockbox-id}/check-details': {
    PUT: { request: ICheckDetailsUpdateDto; response: ICheckDetailsDto };
  };
  '/lockboxes/{lockbox-id}/splitting': {
    POST: { request: IMultipleRecordsDto; response: ILockboxDto };
  };
  '/lockboxes/returned-checks/processing-decisions': {
    POST: { request: IReturnedCheckDecisionsDto; response: IProcessedReturnedChecksDto };
  };
  '/documents/{document-id}/ocrs': {
    POST: { request: IOcrDetailsRequestDto; response: IOcrDetailsDto };
  };
  '/documents/{document-id}/import': {
    POST: { response: IFileUrlsResponseDto };
  };
  '/documents/{document-id}/files': {
    GET: { response: IDocumentFilesUrlDto };
    POST: { request: ICopyFilesRequestDto; response: IDocumentFilesUrlDto };
  };
  '/documents/{document-id}/files/link': {
    POST: { request: IPresignUrlRequestDto; response: IPresignUrlResponse };
  };
  '/documents/{document-id}/files/link/complete': {
    POST: { request: IDocumentFileUploadCompletionDto; response: IFileUrlsResponseDto };
  };
  '/documents/{document-id}/files/by-qr-codes/link': {
    POST: { request: IQrCodePresignUrlRequestDto; response: IPresignUrlResponse };
  };
  '/documents/{document-id}/files/by-qr-codes/link/complete': {
    POST: { request: IDocumentFileUploadByQrCodeDto; response: IFileUrlsResponseDto };
  };
  '/documents/{document-id}/files/by-qr-codes/import': {
    POST: { response: IFileUrlsResponseDto };
  };
  '/documents/{document-id}/files/by-link/link': {
    POST: { request: IOneTimeLinkPresignUrlRequestDto; response: IPresignUrlResponse };
  };
  '/documents/{document-id}/files/by-link/link/complete': {
    POST: { request: IDocumentFileUploadByLinkDto; response: IFileUrlsResponseDto };
  };
  '/documents/{document-id}/files/by-link/import': {
    POST: { response: IFileUrlsResponseDto };
  };
  '/documents/receipts': {
    POST: { request: IReceiptDto; response: IReceiptDto };
  };
  '/documents/receipts/qr-codes': {
    POST: { request: IDocumentIdDto; response: IQrCodeDto };
  };
  '/documents/receipts/draft': {
    POST: { request: IReceiptDto; response: IReceiptDto };
  };
  '/documents/receipts/by-qr-codes': {
    POST: { request: IDocumentQrCodeDto; response: IDocumentIdDto };
  };
  '/documents/receipts/by-link': {
    POST: { request: IDocumentOneTimeLinkDto; response: IDocumentIdDto };
  };
  '/documents/receipts/{receipt-id}': {
    PATCH: { request: IReceiptPatchDto };
  };
  '/documents/files/{file-id}/openai/ocr-reader': {
    PATCH: { request: IOcrDto; response: IOcrReceiptResponseDto };
  };
  '/vendors': {
    GET: { response: IVendorDto };
  };
  '/lockboxes': {
    GET: { response: ILockboxDto };
  };
  '/lockboxes/returned-items': {
    GET: { response: IReturnedItemsDto };
  };
  '/lockboxes/claim-repayment/{lockbox-id}': {
    GET: { response: ILockboxClaimRepaymentDto };
  };
  '/documents/receipts/{receipt-id}/files': {
    GET: { response: IReceiptDocumentFileDto[] };
  };
  '/documents/receipts/ocr': {
    GET: { response: IOcrDetailsDto };
  };
  '/documents/one-time-links/{hash-id}': {
    GET: { response: IOneTimeLinkResponseDto };
  };
  '/documents/files': {
    GET: { response: IDocumentFilesUrlDto[] };
  };
  '/cards/{card-id}': {
    PUT: { request: ICardStatusDto };
  };
  '/cards/verify-last-4': {
    PUT: { request: ICardVerifyDto };
  };
  '/cards/{card-id}/replacement': {
    POST: { request: ICardReplaceDto };
  };
  '/enums/lock-reasons': {
    GET: { response: ILockReasonTypeDto[] };
  };
  '/enums/statuses': {
    GET: { response: IStatusDto };
  };
  '/account-usage/plans': {
    GET: { response: IPlanResponseDto[] };
  };
  '/account-usage/plans/{planId}/plan-details/notional': {
    GET: { response: INotionalDetailsResponseDto };
  };
  '/account-usage/plans/{planId}/plan-details/hsa': {
    GET: { response: IHsaDetailsResponseDto };
  };
  '/account-usage/plans/{planId}/overview/notional': {
    GET: { response: INotionalOverviewResponseDto };
  };
  '/account-usage/plans/{planId}/overview/hsa': {
    GET: { response: IHsaOverviewResponseDto };
  };
  '/account-usage/plans/{planId}/claim-details': {
    GET: { response: IClaimDetailsResponseDto };
  };
  '/account-usage/plans/{planId}/balances/notional': {
    GET: { response: INotionalPlanBalanceMonthlyBreakdownResponseDto };
  };
  '/account-usage/plans/{planId}/balances/hsa': {
    GET: { response: IHsaPlanBalanceMonthlyBreakdownResponseDto };
  };
  '/reports/schedulers/{id}': {
    PUT: { request: IReportSchedulerUpdateDto };
  };
  '/reports/schedulers': {
    POST: { request: IReportSchedulerCreateDto };
  };
  '/metrics/undeliverable-mail': {
    GET: { response: IUndeliverableMailMetricsResponseDto };
  };
  '/metrics/plan-enrollment': {
    GET: { response: IPlanEnrollmentMetricsResponseDto };
  };
  '/metrics/invoice-replenishment': {
    GET: { response: IInvoiceReplenishmentMetricsResponseDto };
  };
  '/metrics/invoice-plan-level-replenishment': {
    GET: { response: IInvoicePlanLevelReplenishmentMetricsResponseDto[] };
  };
  '/metrics/fraud-review-required': {
    GET: { response: IFraudReviewRequiredMetricsResponseDto };
  };
  '/metrics/employer-calendar-events': {
    GET: { response: IEmployerCalendarEventsResponseDto };
  };
  '/metrics/employees': {
    GET: { response: IEmployeeMetricsResponseDto };
  };
  '/metrics/delinquent-claims': {
    GET: { response: IDelinquentClaimsMetricsResponseDto };
  };
  '/metrics/claims-substantiation-rate': {
    GET: { response: IClaimsSubstantiationRateMetricsResponseDto };
  };
  '/metrics/cip-info': {
    GET: { response: ICipInfoMetricsResponseDto };
  };
  '/metrics/cip-config': {
    GET: { response: ICipConfigMetricsResponseDto };
  };
  '/metrics/account-usage/total-claim-spend': {
    GET: { response: ITotalClaimSpendResponseDto[] };
  };
  '/metrics/account-usage/plan-years': {
    GET: { response: IPlanYearResponseDto[] };
  };
  '/providers/{id}': {
    GET: { response: IProviderInfoDto };
    PUT: { request: IUpdateProviderDto; response: IProviderInfoDto };
  };
  '/claims/{claim-id}/process': {
    PUT: { request: IProcessClaimDto };
  };
  '/claims/{claim-id}/process-waiting-for-funds': {
    PUT: { request: IWaitingForFundsDto };
  };
  '/claims/{claim-id}/letter-of-medical-necessity/{lmn-id}': {
    PUT: { response: IClaimInfoResponseDto };
  };
  '/claims/{claim-id}/internal-notes/{note-id}': {
    PUT: { request: IClaimInternalNoteUpdateDto; response: IClaimInternalNoteResponseDto };
  };
  '/claims/{claim-id}/escalation-note': {
    PUT: { request: IClaimEscalationNoteRequestDto };
  };
  '/claims/{claim-id}/employee-process': {
    PUT: { request: IEmployeeChoiceDto };
  };
  '/carriers/{id}': {
    GET: { response: ICarrierDto };
    PUT: { request: ICarrierDto; response: ICarrierDto };
  };
  '/claims/{claim-id}/transfer': {
    POST: { request: IClaimTransferCreateBatchDto };
  };
  '/claims/{claim-id}/rollover-transfer': {
    POST: { request: IRolloverTransferRequestDto };
  };
  '/claims/{claim-id}/appeal': {
    POST: { request: IClaimAppealRequestDto };
  };
  '/claims/{claim-id}/appeal/document': {
    POST: { response: IClaimAppealDocumentUploadResponseDto };
  };
  '/claims/unassign-contact': {
    POST: { request: IClaimAssignRequestDto };
  };
  '/claims/internal-notes': {
    POST: { request: IClaimInternalNoteRequestDto; response: IClaimInternalNoteResponseDto };
  };
  '/claims/hsa-withdrawals': {
    POST: { request: ICreateHsaWithdrawalClaimDto; response: IClaimInfoResponseDto };
  };
  '/claims/claim/{claim-id}/escalate': {
    POST: { request: IClaimEscalationNoteRequestDto };
  };
  '/claims/assign-contact': {
    POST: { request: IClaimAssignRequestDto };
  };
  '/carriers': {
    GET: { response: ICarrierDto };
    POST: { request: ICarrierDto; response: ICarrierDto };
  };
  '/letters-of-medical-necessity/{id}': {
    GET: { response: ILetterOfMedicalNecessityDto };
    PATCH: { request: ILetterOfMedicalNecessityPatchDto; response: ILetterOfMedicalNecessityDto };
  };
  '/carrier-configs/disable/{id}': {
    PATCH: { response: ICarrierConfigDto };
  };
  '/expenses': {
    GET: { response: ICustomPageExpenseInfoDto };
  };
  '/expenses/statistics': {
    GET: { response: IExpenseStatisticsResponseDto };
  };
  '/enums/claim-status': {
    GET: { response: IClaimStatusTypeDto[] };
  };
  '/enums/claim-approval-status-code': {
    GET: { response: IClaimApprovalStatusCodeDto[] };
  };
  '/claims/{claim-id}/transfer/calculate': {
    GET: { response: IClaimTransferCalculationsDto };
  };
  '/claims/search/activities': {
    GET: { response: IClaimActivitiesViewDto };
  };
  '/carrier-configs/{id}': {
    GET: { response: ICarrierConfigDto };
  };
  '/payroll-calendars/{id}': {
    PUT: { request: IPayrollCalendarUpdateDto; response: IPayrollCalendarDto };
  };
  '/payroll-calendars/{calendar-id}/partner': {
    PUT: { request: IPayrollCalendarUpdatePartnerRequestDto };
  };
  '/scheduled-contributions': {
    POST: { request: IScheduledContributionRequestDto; response: IScheduledContributionResponseDto };
  };
  '/records/tax-years-change': {
    POST: { request: IRecordTaxYearChangeCreateDto };
  };
  '/payroll-groups': {
    POST: { request: IPayrollGroupRequestDto; response: IPayrollGroupDto };
  };
  '/payroll-calendars': {
    POST: { request: IPayrollCalendarRequestDto };
  };
  '/payroll-calendars/partner': {
    POST: { request: IPayrollCalendarPartnerRequestDto };
  };
  '/contributions/contribution-requests': {
    GET: { response: IContributionSearchResponseInfoDto };
    POST: { request: IContributionRequestDto };
  };
  '/scheduled-contributions/{id}': {
    PATCH: { request: IScheduledContributionUpdateDto; response: IScheduledContributionResponseDto };
  };
  '/scheduled-contributions/{id}/status': {
    PATCH: { response: IScheduledContributionResponseDto };
  };
  '/payroll-groups/{id}': {
    GET: { response: IPayrollGroupDto };
    PATCH: { request: IPayrollGroupPatchRequestDto; response: IPayrollGroupDto };
  };
  '/contributions/contribution-requests/{request_id}/status': {
    PATCH: { response: IContributionSegmentResponseDto };
  };
  '/segments': {
    GET: { response: IContributionSegmentResponseDto };
  };
  '/scheduled-contributions/organization': {
    GET: { response: IScheduledCalendarDto };
  };
  '/payroll-groups/organizations/{org-id}': {
    GET: { response: IPayrollGroupDto[] };
  };
  '/payroll-calendars/organizations/{organization-id}': {
    GET: { response: IPayrollCalendarResponseDto[] };
  };
  '/payroll-calendars/organizations/{id}/reduced': {
    GET: { response: IPayrollCalendarReducedDto[] };
  };
  '/payroll-calendars/organizations/organization-path/reduced': {
    GET: { response: IPayrollCalendarReducedDto[] };
  };
  '/contributions/v2/amounts/by-plan': {
    GET: { response: IContributionAmountDetailsDto[] };
  };
  '/contributions/contribution-requests/{contribution_request_id}': {
    GET: { response: IContributionResponseDto };
  };
  '/contributions/contribution-requests/{contribution_request_id}/records-identifiers': {
    GET: { response: IContributionRecordIdentifier[] };
  };
  '/contributions/contribution-requests/activity': {
    GET: { response: IContributionActivityRecordResponseDto };
  };
  '/investors': {
    GET: { response: IInvestorDto };
  };
  '/investors/{id}/risk-tolerance-model': {
    PATCH: { response: IRiskToleranceModelResponseDto };
  };
  '/investments/flows/questionnaire': {
    PATCH: { request: IQuestionnaireDto };
  };
  '/trades/amounts': {
    GET: { response: ITradingAmountsDto };
  };
  '/investors/performance/pnl': {
    GET: { response: IAggregatedPnlMetricDto };
  };
  '/investors/base': {
    GET: { response: IInvestorBaseDto[] };
  };
  '/investment-portfolios/proposed': {
    GET: { response: IPortfolioFundAssetDto[] };
  };
  '/external-templates/available': {
    GET: { response: IExternalTemplateLiteDto[] };
  };
  '/email-template-themes': {
    GET: { response: IEmailTemplateThemeDto[] };
  };
  '/communications': {
    GET: { response: ICommunicationDto };
  };
  '/app-notifications': {
    GET: { response: IAppNotificationDto[] };
  };
  '/census': {
    POST: { request: ICensusRequestBatchDto };
  };
  '/census/{requestId}': {
    GET: { response: ICensusResultDto };
  };
  '/checks/{check_id}/void': {
    PUT: { request: ICheckVoidDto };
  };
  '/checks/{check_id}/reissue': {
    PUT: { request: ICheckReissueDto };
  };
  '/tokens': {
    POST: { request: ICreateTokenRequest };
  };
  '/recipients/{merchantCustomerId}/accounts': {
    POST: { request: IAddVaultedAccountRequest; response: IAddVaultedAccountResponse };
  };
  '/maintenance/card': {
    POST: { response: IAccountMaintUpdateResult };
  };
  '/account-tokens': {
    POST: { request: ITokenizeAccountRequest };
  };
  '/interest-rate-templates/{template-id}': {
    GET: { response: IInterestRateTemplateDto };
  };
  '/interest-rate-templates/{template-id}/versions/{version-id}': {
    GET: { response: IInterestRateTemplateDto };
  };
  '/interest-rate-templates/{template-id}/versions/latest': {
    GET: { response: IInterestRateTemplateDto };
  };
  '/prefund-returns/approve': {
    POST: { request: IPrefundReturnApproveDto };
  };
  '/eoy-plan-reconciliations/approve': {
    POST: { request: IEoyPlanReconciliationApproveDto };
  };
  '/tax-forms/mailing-history': {
    POST: { request: ITaxFormMailingCreateDto };
  };
  '/tax-forms/excess-contributions': {
    POST: { request: ICreateExcessContributionFormDto };
  };
  '/tax-forms/excess-contributions/file-upload': {
    POST: { response: IExcessContributionFileResponseDto };
  };
  '/idology/questionnaire-answers': {
    POST: { request: ICipQuestionnaireAnswersRequestDto };
  };
  '/idology/challenge-answers': {
    POST: { request: ICipChallengeAnswerRequestDto };
  };
  '/manual-contribution/coverage-periods': {
    POST: { request: IEmployeePlanCodeDto[]; response: ICoveragePeriodDto[] };
  };
  '/claims/search/participant': {
    POST: { request: IClaimParticipantSearchDto; response: IClaimParticipantResponseDto };
  };
  '/scheduled-contribution-search/organization': {
    GET: { response: IScheduledCalendarDto };
  };
  '/plaid/link-token': {
    POST: { response: ILinkTokenResponseDto };
  };
  '/plaid/exchange-token': {
    POST: { request: IExchangeTokenRequestDto };
  };
  '/bank-accounts/verification-status': {
    POST: { request: IUpdateAccountVerificationStatusDto };
  };
}

export const API_URL = {
  ACCOUNT_ORDERS: '/account-orders' as TypedPath<'/account-orders'>,
  ACCOUNT_ORDERS_SERVICES: '/account-orders/services' as TypedPath<'/account-orders/services'>,
  ACCOUNT_TOKENS: '/account-tokens' as TypedPath<'/account-tokens'>,
  ACCOUNT_USAGE_PLANS: '/account-usage/plans' as TypedPath<'/account-usage/plans'>,
  ACCOUNT_USAGE_PLANS_BALANCES_HSA_BY_PLAN_ID: (planId: string | number) => `/account-usage/plans/${planId}/balances/hsa` as TypedPath<'/account-usage/plans/{planId}/balances/hsa'>,
  ACCOUNT_USAGE_PLANS_BALANCES_NOTIONAL_BY_PLAN_ID: (planId: string | number) => `/account-usage/plans/${planId}/balances/notional` as TypedPath<'/account-usage/plans/{planId}/balances/notional'>,
  ACCOUNT_USAGE_PLANS_CLAIM_DETAILS_BY_PLAN_ID: (planId: string | number) => `/account-usage/plans/${planId}/claim-details` as TypedPath<'/account-usage/plans/{planId}/claim-details'>,
  ACCOUNT_USAGE_PLANS_OVERVIEW_HSA_BY_PLAN_ID: (planId: string | number) => `/account-usage/plans/${planId}/overview/hsa` as TypedPath<'/account-usage/plans/{planId}/overview/hsa'>,
  ACCOUNT_USAGE_PLANS_OVERVIEW_NOTIONAL_BY_PLAN_ID: (planId: string | number) => `/account-usage/plans/${planId}/overview/notional` as TypedPath<'/account-usage/plans/{planId}/overview/notional'>,
  ACCOUNT_USAGE_PLANS_PLAN_DETAILS_HSA_BY_PLAN_ID: (planId: string | number) => `/account-usage/plans/${planId}/plan-details/hsa` as TypedPath<'/account-usage/plans/{planId}/plan-details/hsa'>,
  ACCOUNT_USAGE_PLANS_PLAN_DETAILS_NOTIONAL_BY_PLAN_ID: (planId: string | number) => `/account-usage/plans/${planId}/plan-details/notional` as TypedPath<'/account-usage/plans/{planId}/plan-details/notional'>,
  ACCOUNTS: '/accounts' as TypedPath<'/accounts'>,
  ACCOUNTS_BATCH: '/accounts/batch' as TypedPath<'/accounts/batch'>,
  ACCOUNTS_CALCULATE_TOTAL_BALANCE: '/accounts/calculate-total-balance' as TypedPath<'/accounts/calculate-total-balance'>,
  ACCOUNTS_CLOSE: '/accounts/close' as TypedPath<'/accounts/close'>,
  ACCOUNTS_CLOSURE_AMOUNTS: '/accounts/closure-amounts' as TypedPath<'/accounts/closure-amounts'>,
  ACCOUNTS_HSA: '/accounts/hsa' as TypedPath<'/accounts/hsa'>,
  ACCOUNTS_HSA_NUMBER_BY_ACCOUNT_ID: (accountId: string | number) => `/accounts/hsa/${accountId}/number` as TypedPath<'/accounts/hsa/{account-id}/number'>,
  ACCOUNTS_INTERNAL_NUMBER_BY_ACCOUNT_ID: (accountId: string | number) => `/accounts/internal/${accountId}/number` as TypedPath<'/accounts/internal/{account-id}/number'>,
  ACCOUNTS_MATCHES: '/accounts/matches' as TypedPath<'/accounts/matches'>,
  ACCOUNTS_NUMBER_LAST4_DECRYPT: '/accounts/number/last4/decrypt' as TypedPath<'/accounts/number/last4/decrypt'>,
  ACCOUNTS_VERIFICATION: '/accounts/verification' as TypedPath<'/accounts/verification'>,
  ACCOUNTS_NUMBER_DECRYPTED_BY_ACCOUNT_ID: (accountId: string | number) => `/accounts/${accountId}/number/decrypted` as TypedPath<'/accounts/{account-id}/number/decrypted'>,
  ACCOUNTS_BY_ID: (id: string | number) => `/accounts/${id}` as TypedPath<'/accounts/{id}'>,
  ACH_RETURNS_BY_INDIVIDUAL_IDENTIFICATION_NUMBER: (individual_identification_number: string | number) => `/ach-returns/${individual_identification_number}` as TypedPath<'/ach-returns/{individual_identification_number}'>,
  ACTIVITIES_ACCOUNTS_BY_ACCOUNT_ID: (accountId: string | number) => `/activities/accounts/${accountId}` as TypedPath<'/activities/accounts/{account-id}'>,
  ACTIVITIES_ACCOUNTS_TRANSACTION_TYPES_BY_ACCOUNT_ID: (accountId: string | number) => `/activities/accounts/${accountId}/transaction-types` as TypedPath<'/activities/accounts/{account-id}/transaction-types'>,
  ACTIVITIES_CARDS: '/activities/cards' as TypedPath<'/activities/cards'>,
  ACTIVITIES_CLAIMS_BY_CLAIM_ID: (claimId: string | number) => `/activities/claims/${claimId}` as TypedPath<'/activities/claims/{claimId}'>,
  ACTIVITIES_POSTINGS_BY_POSTING_ID: (postingId: string | number) => `/activities/postings/${postingId}` as TypedPath<'/activities/postings/{postingId}'>,
  ACTIVITIES_POSTINGS_PAYMENT_DETAILS_BY_POSTING_ID: (postingId: string | number) => `/activities/postings/${postingId}/payment-details` as TypedPath<'/activities/postings/{postingId}/payment-details'>,
  ACTIVITY_LOGS: '/activity-logs' as TypedPath<'/activity-logs'>,
  ACTIVITY_LOGS_MAP: '/activity-logs-map' as TypedPath<'/activity-logs-map'>,
  ACTIVITY_LOGS_BY_CHANGESET_ID: (changesetId: string | number) => `/activity-logs/${changesetId}` as TypedPath<'/activity-logs/{changeset-id}'>,
  ADDRESSES_CONFIRM_BY_ADDRESS_ID: (addressId: string | number) => `/addresses/${addressId}/confirm` as TypedPath<'/addresses/{address-id}/confirm'>,
  AI_SEARCH_SERVICES_BY_PLAN: '/ai/search/services/by-plan' as TypedPath<'/ai/search/services/by-plan'>,
  AI_SEARCH_SERVICES_ELIGIBLE: '/ai/search/services/eligible' as TypedPath<'/ai/search/services/eligible'>,
  APP_CLIENTS: '/app-clients' as TypedPath<'/app-clients'>,
  APP_NOTIFICATIONS: '/app-notifications' as TypedPath<'/app-notifications'>,
  APP_NOTIFICATIONS_DISMISSED: '/app-notifications/dismissed' as TypedPath<'/app-notifications/dismissed'>,
  APP_NOTIFICATIONS_DISMISSED_BY_CORRESPONDENCE_ID: (correspondenceId: string | number) => `/app-notifications/dismissed/${correspondenceId}` as TypedPath<'/app-notifications/dismissed/{correspondence-id}'>,
  APP_NOTIFICATIONS_READ: '/app-notifications/read' as TypedPath<'/app-notifications/read'>,
  APP_NOTIFICATIONS_SENT: '/app-notifications/sent' as TypedPath<'/app-notifications/sent'>,
  APP_NOTIFICATIONS_STREAM: '/app-notifications/stream' as TypedPath<'/app-notifications/stream'>,
  APPLICATION_USER_BY_USERNAME: (username: string | number) => `/application-user/${username}` as TypedPath<'/application-user/{username}'>,
  APPLICATION_USER_LOCK_BY_USERNAME: (username: string | number) => `/application-user/${username}/lock` as TypedPath<'/application-user/{username}/lock'>,
  APPLICATION_USER_UNLOCK_BY_USERNAME: (username: string | number) => `/application-user/${username}/unlock` as TypedPath<'/application-user/{username}/unlock'>,
  APPLICATION_USERS_LINKED_BY_LINK_ID: (linkId: string | number) => `/application-users/linked/${linkId}` as TypedPath<'/application-users/linked/{link-id}'>,
  APPLICATION_USERS_ROLE: '/application-users/role' as TypedPath<'/application-users/role'>,
  ATTRIBUTES_LIST: '/attributes-list' as TypedPath<'/attributes-list'>,
  AUDIT_CHANGESETS_ATTRIBUTES_BY_CHANGESET_ID: (changeset_id: string | number) => `/audit/changesets/${changeset_id}/attributes` as TypedPath<'/audit/changesets/{changeset_id}/attributes'>,
  AUDIT_CHANGESETS_SEARCH_BY_CHANGESET_ID: (changeset_id: string | number) => `/audit/changesets/${changeset_id}/search` as TypedPath<'/audit/changesets/{changeset_id}/search'>,
  AUDIT_CONTRIBUTION_REQUESTS_CHANGESETS_BY_REQUEST_ID: (request_id: string | number) => `/audit/contribution-requests/${request_id}/changesets` as TypedPath<'/audit/contribution-requests/{request_id}/changesets'>,
  AUTHORIZED_USERS: '/authorized-users' as TypedPath<'/authorized-users'>,
  AUTHORIZED_USERS_BY_ID: (id: string | number) => `/authorized-users/${id}` as TypedPath<'/authorized-users/{id}'>,
  AUTHORIZED_USERS_ACTIVATE_BY_ID: (id: string | number) => `/authorized-users/${id}/activate` as TypedPath<'/authorized-users/{id}/activate'>,
  AUTHORIZED_USERS_DEACTIVATE_BY_ID: (id: string | number) => `/authorized-users/${id}/deactivate` as TypedPath<'/authorized-users/{id}/deactivate'>,
  BALANCE_ADJUSTMENT: '/balance-adjustment' as TypedPath<'/balance-adjustment'>,
  BANK_ACCOUNTS_VERIFICATION_STATUS: '/bank-accounts/verification-status' as TypedPath<'/bank-accounts/verification-status'>,
  BANNERS_DISMISSED: '/banners/dismissed' as TypedPath<'/banners/dismissed'>,
  BANNERS_DISMISS_BY_BANNER_KEY: (bannerKey: string | number) => `/banners/${bannerKey}/dismiss` as TypedPath<'/banners/{bannerKey}/dismiss'>,
  CARD_HOLDERS: '/card-holders' as TypedPath<'/card-holders'>,
  CARD_PURSES: '/card-purses' as TypedPath<'/card-purses'>,
  CARD_PROVISION_BY_CARD_ID: (card_id: string | number) => `/card/${card_id}/provision` as TypedPath<'/card/{card_id}/provision'>,
  CARD_WALLETS_BY_CARD_ID: (card_id: string | number) => `/card/${card_id}/wallets` as TypedPath<'/card/{card_id}/wallets'>,
  CARDS_VERIFY: '/cards/verify' as TypedPath<'/cards/verify'>,
  CARDS_VERIFY_LAST_4: '/cards/verify-last-4' as TypedPath<'/cards/verify-last-4'>,
  CARDS_BY_CARD_ID: (cardId: string | number) => `/cards/${cardId}` as TypedPath<'/cards/{card-id}'>,
  CARDS_FRAUD_CONFIRMATION_BY_CARD_ID: (cardId: string | number) => `/cards/${cardId}/fraud-confirmation` as TypedPath<'/cards/{card-id}/fraud-confirmation'>,
  CARDS_PROVISION_NOTIFICATION_BY_CARD_ID: (cardId: string | number) => `/cards/${cardId}/provision-notification` as TypedPath<'/cards/{card-id}/provision-notification'>,
  CARDS_REPLACEMENT_BY_CARD_ID: (cardId: string | number) => `/cards/${cardId}/replacement` as TypedPath<'/cards/{card-id}/replacement'>,
  CARDS_SHIPMENT_EVENTS_BY_CARD_ID: (cardId: string | number) => `/cards/${cardId}/shipment-events` as TypedPath<'/cards/{card-id}/shipment-events'>,
  CARDS_VERIFICATION_BY_CARD_ID: (cardId: string | number) => `/cards/${cardId}/verification` as TypedPath<'/cards/{card-id}/verification'>,
  CARRIER_CONFIGS: '/carrier-configs' as TypedPath<'/carrier-configs'>,
  CARRIER_CONFIGS_DISABLE_BY_ID: (id: string | number) => `/carrier-configs/disable/${id}` as TypedPath<'/carrier-configs/disable/{id}'>,
  CARRIER_CONFIGS_BY_ID: (id: string | number) => `/carrier-configs/${id}` as TypedPath<'/carrier-configs/{id}'>,
  CARRIERS: '/carriers' as TypedPath<'/carriers'>,
  CARRIERS_BY_ID: (id: string | number) => `/carriers/${id}` as TypedPath<'/carriers/{id}'>,
  CATEGORIES: '/categories' as TypedPath<'/categories'>,
  CATEGORIES_SERVICES: '/categories/services' as TypedPath<'/categories/services'>,
  CATEGORY_SPEND_LIMITS: '/category-spend-limits' as TypedPath<'/category-spend-limits'>,
  CENSUS: '/census' as TypedPath<'/census'>,
  CENSUS_BY_REQUEST_ID: (requestId: string | number) => `/census/${requestId}` as TypedPath<'/census/{requestId}'>,
  CHECKS_SEARCH: '/checks/search' as TypedPath<'/checks/search'>,
  CHECKS_REISSUE_BY_CHECK_ID: (checkId: string | number) => `/checks/${checkId}/reissue` as TypedPath<'/checks/{check-id}/reissue'>,
  CHECKS_VOID_BY_CHECK_ID: (checkId: string | number) => `/checks/${checkId}/void` as TypedPath<'/checks/{check-id}/void'>,
  CHECKS_REISSUE_BY_CHECK_ID_2: (check_id: string | number) => `/checks/${check_id}/reissue` as TypedPath<'/checks/{check_id}/reissue'>,
  CHECKS_VOID_BY_CHECK_ID_2: (check_id: string | number) => `/checks/${check_id}/void` as TypedPath<'/checks/{check_id}/void'>,
  CIP_INFOS_EMPLOYEE_ID: '/cip-infos/employee-id' as TypedPath<'/cip-infos/employee-id'>,
  CLAIMS: '/claims' as TypedPath<'/claims'>,
  CLAIMS_TEAMS: '/claims-teams' as TypedPath<'/claims-teams'>,
  CLAIMS_TEAMS_SEARCH: '/claims-teams/search' as TypedPath<'/claims-teams/search'>,
  CLAIMS_TEAMS_SEARCH_ASSIGNED: '/claims-teams/search-assigned' as TypedPath<'/claims-teams/search-assigned'>,
  CLAIMS_TEAMS_BY_CLAIMS_TEAM_ID: (claimsTeamId: string | number) => `/claims-teams/${claimsTeamId}` as TypedPath<'/claims-teams/{claims-team-id}'>,
  CLAIMS_TEAMS_CONTACTS_BY_CLAIMS_TEAM_ID: (claimsTeamId: string | number) => `/claims-teams/${claimsTeamId}/contacts` as TypedPath<'/claims-teams/{claims-team-id}/contacts'>,
  CLAIMS_ASSIGN_CONTACT: '/claims/assign-contact' as TypedPath<'/claims/assign-contact'>,
  CLAIMS_CLAIM_ESCALATE_BY_CLAIM_ID: (claimId: string | number) => `/claims/claim/${claimId}/escalate` as TypedPath<'/claims/claim/{claim-id}/escalate'>,
  CLAIMS_HSA_WITHDRAWALS: '/claims/hsa-withdrawals' as TypedPath<'/claims/hsa-withdrawals'>,
  CLAIMS_INTERNAL_NOTES: '/claims/internal-notes' as TypedPath<'/claims/internal-notes'>,
  CLAIMS_PAYMENT_DETAILS: '/claims/payment-details' as TypedPath<'/claims/payment-details'>,
  CLAIMS_REPAYMENT_MATCHES: '/claims/repayment/matches' as TypedPath<'/claims/repayment/matches'>,
  CLAIMS_RETRY_PAYMENT: '/claims/retry-payment' as TypedPath<'/claims/retry-payment'>,
  CLAIMS_SEARCH: '/claims/search' as TypedPath<'/claims/search'>,
  CLAIMS_SEARCH_ACTIVITIES: '/claims/search/activities' as TypedPath<'/claims/search/activities'>,
  CLAIMS_SEARCH_PARTICIPANT: '/claims/search/participant' as TypedPath<'/claims/search/participant'>,
  CLAIMS_UNASSIGN_CONTACT: '/claims/unassign-contact' as TypedPath<'/claims/unassign-contact'>,
  CLAIMS_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}` as TypedPath<'/claims/{claim-id}'>,
  CLAIMS_APPEAL_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}/appeal` as TypedPath<'/claims/{claim-id}/appeal'>,
  CLAIMS_APPEAL_DOCUMENT_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}/appeal/document` as TypedPath<'/claims/{claim-id}/appeal/document'>,
  CLAIMS_AVAILABLE_ROLLOVER_TO_APPLY_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}/available-rollover-to-apply` as TypedPath<'/claims/{claim-id}/available-rollover-to-apply'>,
  CLAIMS_DOCUMENT_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}/document` as TypedPath<'/claims/{claim-id}/document'>,
  CLAIMS_DOCUMENTS_ONE_TIME_LINKS_BY_CLAIM_ID_HASH_ID: (claimId: string | number, hashId: string | number) => `/claims/${claimId}/documents/one-time-links/${hashId}` as TypedPath<'/claims/{claim-id}/documents/one-time-links/{hash-id}'>,
  CLAIMS_EMPLOYEE_PROCESS_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}/employee-process` as TypedPath<'/claims/{claim-id}/employee-process'>,
  CLAIMS_ESCALATION_NOTE_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}/escalation-note` as TypedPath<'/claims/{claim-id}/escalation-note'>,
  CLAIMS_INTERNAL_NOTES_BY_CLAIM_ID_NOTE_ID: (claimId: string | number, noteId: string | number) => `/claims/${claimId}/internal-notes/${noteId}` as TypedPath<'/claims/{claim-id}/internal-notes/{note-id}'>,
  CLAIMS_LETTER_OF_MEDICAL_NECESSITY_BY_CLAIM_ID_LMN_ID: (claimId: string | number, lmnId: string | number) => `/claims/${claimId}/letter-of-medical-necessity/${lmnId}` as TypedPath<'/claims/{claim-id}/letter-of-medical-necessity/{lmn-id}'>,
  CLAIMS_PROCESS_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}/process` as TypedPath<'/claims/{claim-id}/process'>,
  CLAIMS_PROCESS_WAITING_FOR_FUNDS_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}/process-waiting-for-funds` as TypedPath<'/claims/{claim-id}/process-waiting-for-funds'>,
  CLAIMS_REJECTED_CLAIM_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}/rejected-claim` as TypedPath<'/claims/{claim-id}/rejected-claim'>,
  CLAIMS_RELATED_CARD_SWIPES_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}/related-card-swipes` as TypedPath<'/claims/{claim-id}/related-card-swipes'>,
  CLAIMS_ROLLOVER_TRANSFER_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}/rollover-transfer` as TypedPath<'/claims/{claim-id}/rollover-transfer'>,
  CLAIMS_START_REPAYMENT_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}/start-repayment` as TypedPath<'/claims/{claim-id}/start-repayment'>,
  CLAIMS_TRANSFER_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}/transfer` as TypedPath<'/claims/{claim-id}/transfer'>,
  CLAIMS_TRANSFER_AMOUNT_AVAILABLE_BY_CLAIM_ID_ACCOUNT_FROM_ID: (claimId: string | number, accountFromId: string | number) => `/claims/${claimId}/transfer-amount-available/${accountFromId}` as TypedPath<'/claims/{claim-id}/transfer-amount-available/{account-from-id}'>,
  CLAIMS_TRANSFER_CALCULATE_BY_CLAIM_ID: (claimId: string | number) => `/claims/${claimId}/transfer/calculate` as TypedPath<'/claims/{claim-id}/transfer/calculate'>,
  CODES_VERIFICATIONS: '/codes/verifications' as TypedPath<'/codes/verifications'>,
  CODES_VERIFICATIONS_VALIDATION: '/codes/verifications/validation' as TypedPath<'/codes/verifications/validation'>,
  COMBINE_HSA_FILE_UPLOAD: '/combine-hsa/file-upload' as TypedPath<'/combine-hsa/file-upload'>,
  COMMUNICATIONS: '/communications' as TypedPath<'/communications'>,
  COMMUNICATIONS_RESEND_BY_ID: (id: string | number) => `/communications/${id}/resend` as TypedPath<'/communications/{id}/resend'>,
  CONTACTS: '/contacts' as TypedPath<'/contacts'>,
  CONTACTS_ALL: '/contacts/all' as TypedPath<'/contacts/all'>,
  CONTACTS_ALL_LITE: '/contacts/all/lite' as TypedPath<'/contacts/all/lite'>,
  CONTACTS_APPEAL_ELIGIBLE: '/contacts/appeal-eligible' as TypedPath<'/contacts/appeal-eligible'>,
  CONTACTS_CODES: '/contacts/codes' as TypedPath<'/contacts/codes'>,
  CONTACTS_CODES_VERIFICATIONS: '/contacts/codes/verifications' as TypedPath<'/contacts/codes/verifications'>,
  CONTACTS_COUNT_BY_ROLE: '/contacts/count-by-role' as TypedPath<'/contacts/count-by-role'>,
  CONTACTS_EMAIL_VERIFICATIONS: '/contacts/email/verifications' as TypedPath<'/contacts/email/verifications'>,
  CONTACTS_MFA_CODES: '/contacts/mfa/codes' as TypedPath<'/contacts/mfa/codes'>,
  CONTACTS_MFA_CODES_VERIFICATIONS: '/contacts/mfa/codes/verifications' as TypedPath<'/contacts/mfa/codes/verifications'>,
  CONTACTS_REFRESH: '/contacts/refresh' as TypedPath<'/contacts/refresh'>,
  CONTACTS_SIGNIN: '/contacts/signin' as TypedPath<'/contacts/signin'>,
  CONTACTS_TEAMS: '/contacts/teams' as TypedPath<'/contacts/teams'>,
  CONTACTS_UP_HIERARCHY: '/contacts/up-hierarchy' as TypedPath<'/contacts/up-hierarchy'>,
  CONTACTS_USERNAMES_EXISTS: '/contacts/usernames/exists' as TypedPath<'/contacts/usernames/exists'>,
  CONTACTS_USERNAMES_FORGOT: '/contacts/usernames/forgot' as TypedPath<'/contacts/usernames/forgot'>,
  CONTACTS_VERIFICATION_CODES: '/contacts/verification-codes' as TypedPath<'/contacts/verification-codes'>,
  CONTACTS_BY_CONTACT_ID: (contactId: string | number) => `/contacts/${contactId}` as TypedPath<'/contacts/{contact-id}'>,
  CONTACTS_CLAIMS_TEAMS_BY_CONTACT_ID: (contactId: string | number) => `/contacts/${contactId}/claims-teams` as TypedPath<'/contacts/{contact-id}/claims-teams'>,
  CONTACTS_CLOCK_IN_BY_CONTACT_ID: (contactId: string | number) => `/contacts/${contactId}/clock-in` as TypedPath<'/contacts/{contact-id}/clock-in'>,
  CONTACTS_EXPRESS_BY_CONTACT_ID: (contactId: string | number) => `/contacts/${contactId}/express` as TypedPath<'/contacts/{contact-id}/express'>,
  CONTACTS_UNASSIGN_ACCOUNT_MANAGER_BY_CONTACT_ID: (contactId: string | number) => `/contacts/${contactId}/unassign-account-manager` as TypedPath<'/contacts/{contact-id}/unassign-account-manager'>,
  CONTRIBUTION_REQUESTS: '/contribution-requests' as TypedPath<'/contribution-requests'>,
  CONTRIBUTION_REQUESTS_IRS_LIMITS: '/contribution-requests/irs-limits' as TypedPath<'/contribution-requests/irs-limits'>,
  CONTRIBUTION_REQUESTS_IRS_LIMITS_SEARCH: '/contribution-requests/irs-limits/search' as TypedPath<'/contribution-requests/irs-limits/search'>,
  CONTRIBUTION_REQUESTS_RECORDS_TAX_YEARS: '/contribution-requests/records/tax-years' as TypedPath<'/contribution-requests/records/tax-years'>,
  CONTRIBUTION_REQUESTS_RECORDS_TAX_YEARS_CHANGE: '/contribution-requests/records/tax-years-change' as TypedPath<'/contribution-requests/records/tax-years-change'>,
  CONTRIBUTIONS_CONTRIBUTION_REQUESTS: '/contributions/contribution-requests' as TypedPath<'/contributions/contribution-requests'>,
  CONTRIBUTIONS_CONTRIBUTION_REQUESTS_ACTIVITY: '/contributions/contribution-requests/activity' as TypedPath<'/contributions/contribution-requests/activity'>,
  CONTRIBUTIONS_CONTRIBUTION_REQUESTS_ACTIVITY_CSV_REPORT: '/contributions/contribution-requests/activity/csv-report' as TypedPath<'/contributions/contribution-requests/activity/csv-report'>,
  CONTRIBUTIONS_CONTRIBUTION_REQUESTS_EMPLOYEE: '/contributions/contribution-requests/employee' as TypedPath<'/contributions/contribution-requests/employee'>,
  CONTRIBUTIONS_CONTRIBUTION_REQUESTS_BY_CONTRIBUTION_REQUEST_ID: (contribution_request_id: string | number) => `/contributions/contribution-requests/${contribution_request_id}` as TypedPath<'/contributions/contribution-requests/{contribution_request_id}'>,
  CONTRIBUTIONS_CONTRIBUTION_REQUESTS_RECORDS_IDENTIFIERS_BY_CONTRIBUTION_REQUEST_ID: (contribution_request_id: string | number) => `/contributions/contribution-requests/${contribution_request_id}/records-identifiers` as TypedPath<'/contributions/contribution-requests/{contribution_request_id}/records-identifiers'>,
  CONTRIBUTIONS_CONTRIBUTION_REQUESTS_CONTRIBUTION_RECORDS_BY_REQUEST_ID: (request_id: string | number) => `/contributions/contribution-requests/${request_id}/contribution-records` as TypedPath<'/contributions/contribution-requests/{request_id}/contribution-records'>,
  CONTRIBUTIONS_CONTRIBUTION_REQUESTS_CONTRIBUTION_RECORDS_UPDATE_ALL_BY_REQUEST_ID: (request_id: string | number) => `/contributions/contribution-requests/${request_id}/contribution-records/update-all` as TypedPath<'/contributions/contribution-requests/{request_id}/contribution-records/update-all'>,
  CONTRIBUTIONS_CONTRIBUTION_REQUESTS_ERROR_RECORDS_COUNT_BY_REQUEST_ID: (request_id: string | number) => `/contributions/contribution-requests/${request_id}/error-records-count` as TypedPath<'/contributions/contribution-requests/{request_id}/error-records-count'>,
  CONTRIBUTIONS_CONTRIBUTION_REQUESTS_STATUS_BY_REQUEST_ID: (request_id: string | number) => `/contributions/contribution-requests/${request_id}/status` as TypedPath<'/contributions/contribution-requests/{request_id}/status'>,
  CONTRIBUTIONS_V2_AMOUNTS_BY_PLAN: '/contributions/v2/amounts/by-plan' as TypedPath<'/contributions/v2/amounts/by-plan'>,
  COPAY_GROUPS: '/copay-groups' as TypedPath<'/copay-groups'>,
  COPAY_GROUPS_BY_ID: (id: string | number) => `/copay-groups/${id}` as TypedPath<'/copay-groups/{id}'>,
  COUNTRIES: '/countries' as TypedPath<'/countries'>,
  COV_TABLES: '/cov-tables' as TypedPath<'/cov-tables'>,
  COVERAGES: '/coverages' as TypedPath<'/coverages'>,
  DEDUCTIBLES_SERVICES: '/deductibles-services' as TypedPath<'/deductibles-services'>,
  DEDUCTIBLES_EMPLOYEES_BY_EMPLOYEE_ID: (employeeId: string | number) => `/deductibles/employees/${employeeId}` as TypedPath<'/deductibles/employees/{employee-id}'>,
  DEDUCTIBLES_EMPLOYEES_PREVIEW_BY_EMPLOYEE_ID: (employeeId: string | number) => `/deductibles/employees/${employeeId}/preview` as TypedPath<'/deductibles/employees/{employee-id}/preview'>,
  DEPENDENTS: '/dependents' as TypedPath<'/dependents'>,
  DEPENDENTS_EMPLOYEE_BY_EMPLOYEE_ID: (employeeId: string | number) => `/dependents/employee/${employeeId}` as TypedPath<'/dependents/employee/{employee-id}'>,
  DEPENDENTS_NAMES: '/dependents/names' as TypedPath<'/dependents/names'>,
  DEPENDENTS_BY_DEPENDENT_ID: (dependentId: string | number) => `/dependents/${dependentId}` as TypedPath<'/dependents/{dependent-id}'>,
  DOCUMENTS: '/documents' as TypedPath<'/documents'>,
  DOCUMENTS_FILES: '/documents/files' as TypedPath<'/documents/files'>,
  DOCUMENTS_FILES_BY_LINK_OPENAI_OCR_MATCHING_BY_FILE_ID: (fileId: string | number) => `/documents/files/by-link/${fileId}/openai/ocr/matching` as TypedPath<'/documents/files/by-link/{file-id}/openai/ocr/matching'>,
  DOCUMENTS_FILES_BY_FILE_ID: (fileId: string | number) => `/documents/files/${fileId}` as TypedPath<'/documents/files/{file-id}'>,
  DOCUMENTS_FILES_EXISTS_BY_FILE_ID: (fileId: string | number) => `/documents/files/${fileId}/exists` as TypedPath<'/documents/files/{file-id}/exists'>,
  DOCUMENTS_FILES_OCR_READER_BY_FILE_ID: (fileId: string | number) => `/documents/files/${fileId}/ocr-reader` as TypedPath<'/documents/files/{file-id}/ocr-reader'>,
  DOCUMENTS_FILES_OPENAI_OCR_READER_BY_FILE_ID: (fileId: string | number) => `/documents/files/${fileId}/openai/ocr-reader` as TypedPath<'/documents/files/{file-id}/openai/ocr-reader'>,
  DOCUMENTS_FILES_OPENAI_OCR_MATCHING_BY_FILE_ID: (fileId: string | number) => `/documents/files/${fileId}/openai/ocr/matching` as TypedPath<'/documents/files/{file-id}/openai/ocr/matching'>,
  DOCUMENTS_OCR_OPTIONS: '/documents/ocr/options' as TypedPath<'/documents/ocr/options'>,
  DOCUMENTS_ONE_TIME_LINKS_BY_HASH_ID: (hashId: string | number) => `/documents/one-time-links/${hashId}` as TypedPath<'/documents/one-time-links/{hash-id}'>,
  DOCUMENTS_ONE_TIME_LINKS_DEACTIVATION_BY_HASH_ID: (hashId: string | number) => `/documents/one-time-links/${hashId}/deactivation` as TypedPath<'/documents/one-time-links/{hash-id}/deactivation'>,
  DOCUMENTS_RECEIPTS: '/documents/receipts' as TypedPath<'/documents/receipts'>,
  DOCUMENTS_RECEIPTS_BY_LINK: '/documents/receipts/by-link' as TypedPath<'/documents/receipts/by-link'>,
  DOCUMENTS_RECEIPTS_BY_QR_CODES: '/documents/receipts/by-qr-codes' as TypedPath<'/documents/receipts/by-qr-codes'>,
  DOCUMENTS_RECEIPTS_DRAFT: '/documents/receipts/draft' as TypedPath<'/documents/receipts/draft'>,
  DOCUMENTS_RECEIPTS_FILE_BY_QR_CODES_STREAM: '/documents/receipts/file/by-qr-codes/stream' as TypedPath<'/documents/receipts/file/by-qr-codes/stream'>,
  DOCUMENTS_RECEIPTS_FILES: '/documents/receipts/files' as TypedPath<'/documents/receipts/files'>,
  DOCUMENTS_RECEIPTS_OCR: '/documents/receipts/ocr' as TypedPath<'/documents/receipts/ocr'>,
  DOCUMENTS_RECEIPTS_QR_CODES: '/documents/receipts/qr-codes' as TypedPath<'/documents/receipts/qr-codes'>,
  DOCUMENTS_RECEIPTS_BY_RECEIPT_ID: (receiptId: string | number) => `/documents/receipts/${receiptId}` as TypedPath<'/documents/receipts/{receipt-id}'>,
  DOCUMENTS_RECEIPTS_FILES_BY_RECEIPT_ID: (receiptId: string | number) => `/documents/receipts/${receiptId}/files` as TypedPath<'/documents/receipts/{receipt-id}/files'>,
  DOCUMENTS_BY_DOCUMENT_ID: (documentId: string | number) => `/documents/${documentId}` as TypedPath<'/documents/{document-id}'>,
  DOCUMENTS_FILES_BY_DOCUMENT_ID: (documentId: string | number) => `/documents/${documentId}/files` as TypedPath<'/documents/{document-id}/files'>,
  DOCUMENTS_FILES_BY_LINK_IMPORT_BY_DOCUMENT_ID: (documentId: string | number) => `/documents/${documentId}/files/by-link/import` as TypedPath<'/documents/{document-id}/files/by-link/import'>,
  DOCUMENTS_FILES_BY_LINK_LINK_BY_DOCUMENT_ID: (documentId: string | number) => `/documents/${documentId}/files/by-link/link` as TypedPath<'/documents/{document-id}/files/by-link/link'>,
  DOCUMENTS_FILES_BY_LINK_LINK_COMPLETE_BY_DOCUMENT_ID: (documentId: string | number) => `/documents/${documentId}/files/by-link/link/complete` as TypedPath<'/documents/{document-id}/files/by-link/link/complete'>,
  DOCUMENTS_FILES_BY_QR_CODES_IMPORT_BY_DOCUMENT_ID: (documentId: string | number) => `/documents/${documentId}/files/by-qr-codes/import` as TypedPath<'/documents/{document-id}/files/by-qr-codes/import'>,
  DOCUMENTS_FILES_BY_QR_CODES_LINK_BY_DOCUMENT_ID: (documentId: string | number) => `/documents/${documentId}/files/by-qr-codes/link` as TypedPath<'/documents/{document-id}/files/by-qr-codes/link'>,
  DOCUMENTS_FILES_BY_QR_CODES_LINK_COMPLETE_BY_DOCUMENT_ID: (documentId: string | number) => `/documents/${documentId}/files/by-qr-codes/link/complete` as TypedPath<'/documents/{document-id}/files/by-qr-codes/link/complete'>,
  DOCUMENTS_FILES_LINK_BY_DOCUMENT_ID: (documentId: string | number) => `/documents/${documentId}/files/link` as TypedPath<'/documents/{document-id}/files/link'>,
  DOCUMENTS_FILES_LINK_COMPLETE_BY_DOCUMENT_ID: (documentId: string | number) => `/documents/${documentId}/files/link/complete` as TypedPath<'/documents/{document-id}/files/link/complete'>,
  DOCUMENTS_IMPORT_BY_DOCUMENT_ID: (documentId: string | number) => `/documents/${documentId}/import` as TypedPath<'/documents/{document-id}/import'>,
  DOCUMENTS_OCR_BY_DOCUMENT_ID: (documentId: string | number) => `/documents/${documentId}/ocr` as TypedPath<'/documents/{document-id}/ocr'>,
  DOCUMENTS_OCR_OPTIONS_BY_DOCUMENT_ID: (documentId: string | number) => `/documents/${documentId}/ocr/options` as TypedPath<'/documents/{document-id}/ocr/options'>,
  DOCUMENTS_OCRS_BY_DOCUMENT_ID: (documentId: string | number) => `/documents/${documentId}/ocrs` as TypedPath<'/documents/{document-id}/ocrs'>,
  EMAIL_ILLUSTRATIONS: '/email-illustrations' as TypedPath<'/email-illustrations'>,
  EMAIL_TEMPLATE_THEMES: '/email-template-themes' as TypedPath<'/email-template-themes'>,
  EMAILS_CONFIRMATION: '/emails/confirmation' as TypedPath<'/emails/confirmation'>,
  EMPLOYEE_SEARCH_ACTIVE_PLAN: '/employee-search/active-plan' as TypedPath<'/employee-search/active-plan'>,
  EMPLOYEES_ADMIN_SEARCH: '/employees/admin/search' as TypedPath<'/employees/admin/search'>,
  EMPLOYEES_BALANCE_REMINDER: '/employees/balance-reminder' as TypedPath<'/employees/balance-reminder'>,
  EMPLOYEES_COMBINE_HSA_SEARCH: '/employees/combine-hsa-search' as TypedPath<'/employees/combine-hsa-search'>,
  EMPLOYEES_LINKAGE_SEARCH: '/employees/linkage-search' as TypedPath<'/employees/linkage-search'>,
  EMPLOYEES_LINKED_ACCOUNTS: '/employees/linked-accounts' as TypedPath<'/employees/linked-accounts'>,
  EMPLOYEES_MATCHES: '/employees/matches' as TypedPath<'/employees/matches'>,
  EMPLOYEES_NAMES: '/employees/names' as TypedPath<'/employees/names'>,
  EMPLOYEES_PERSONAL_INFO_BY_EMPLOYEE_ID: (employeeId: string | number) => `/employees/personal-info/${employeeId}` as TypedPath<'/employees/personal-info/{employee-id}'>,
  EMPLOYEES_SEARCH: '/employees/search' as TypedPath<'/employees/search'>,
  EMPLOYEES_SEARCH_IDS: '/employees/search/ids' as TypedPath<'/employees/search/ids'>,
  EMPLOYEES_UPDATE_LINKED: '/employees/update-linked' as TypedPath<'/employees/update-linked'>,
  EMPLOYEES_BY_EMPLOYEE_ID: (employeeId: string | number) => `/employees/${employeeId}` as TypedPath<'/employees/{employee-id}'>,
  EMPLOYEES_ACCOUNT_COMBINE_WITH_HSA_BY_EMPLOYEE_ID_ACCOUNT_ID: (employeeId: string | number, accountId: string | number) => `/employees/${employeeId}/account/${accountId}/combine-with-hsa` as TypedPath<'/employees/{employee-id}/account/{account-id}/combine-with-hsa'>,
  EMPLOYEES_AUTHORIZED_USERS_BY_EMPLOYEE_ID: (employeeId: string | number) => `/employees/${employeeId}/authorized-users` as TypedPath<'/employees/{employee-id}/authorized-users'>,
  EMPLOYEES_BAD_DATA_BY_EMPLOYEE_ID: (employeeId: string | number) => `/employees/${employeeId}/bad-data` as TypedPath<'/employees/{employee-id}/bad-data'>,
  EMPLOYEES_BENEFICIARIES_BY_EMPLOYEE_ID: (employeeId: string | number) => `/employees/${employeeId}/beneficiaries` as TypedPath<'/employees/{employee-id}/beneficiaries'>,
  EMPLOYEES_BENEFICIARIES_BY_EMPLOYEE_ID_TYPE: (employeeId: string | number, type: string | number) => `/employees/${employeeId}/beneficiaries/${type}` as TypedPath<'/employees/{employee-id}/beneficiaries/{type}'>,
  EMPLOYEES_CLAIM_CONFIG_BY_EMPLOYEE_ID: (employeeId: string | number) => `/employees/${employeeId}/claim-config` as TypedPath<'/employees/{employee-id}/claim-config'>,
  EMPLOYEES_EMPLOYEE_VIEW_BY_EMPLOYEE_ID: (employeeId: string | number) => `/employees/${employeeId}/employee-view` as TypedPath<'/employees/{employee-id}/employee-view'>,
  EMPLOYEES_FRAUD_CONFIRM_BY_EMPLOYEE_ID: (employeeId: string | number) => `/employees/${employeeId}/fraud-confirm` as TypedPath<'/employees/{employee-id}/fraud-confirm'>,
  EMPLOYEES_FRAUD_REVIEW_BY_EMPLOYEE_ID: (employeeId: string | number) => `/employees/${employeeId}/fraud-review` as TypedPath<'/employees/{employee-id}/fraud-review'>,
  EMPLOYEES_INTERNAL_BY_EMPLOYEE_ID: (employeeId: string | number) => `/employees/${employeeId}/internal` as TypedPath<'/employees/{employee-id}/internal'>,
  EMPLOYEES_LINK_BY_EMPLOYEE_ID: (employeeId: string | number) => `/employees/${employeeId}/link` as TypedPath<'/employees/{employee-id}/link'>,
  EMPLOYEES_SSO_SIGNUP_BY_EMPLOYEE_ID: (employeeId: string | number) => `/employees/${employeeId}/sso-signup` as TypedPath<'/employees/{employee-id}/sso-signup'>,
  ENCRYPTION_PUBLIC_KEY: '/encryption/public-key' as TypedPath<'/encryption/public-key'>,
  ENROLLMENT_MATRIXES: '/enrollment-matrixes' as TypedPath<'/enrollment-matrixes'>,
  ENROLLMENT_MATRIXES_CLOSEST: '/enrollment-matrixes/closest' as TypedPath<'/enrollment-matrixes/closest'>,
  ENROLLMENT_MATRIXES_EXPIRED: '/enrollment-matrixes/expired' as TypedPath<'/enrollment-matrixes/expired'>,
  ENROLLMENT_MATRIXES_BY_ID: (id: string | number) => `/enrollment-matrixes/${id}` as TypedPath<'/enrollment-matrixes/{id}'>,
  ENROLLMENTS: '/enrollments' as TypedPath<'/enrollments'>,
  ENUMS_ACCOUNT_CATEGORIES: '/enums/account-categories' as TypedPath<'/enums/account-categories'>,
  ENUMS_ACCOUNT_TYPES: '/enums/account-types' as TypedPath<'/enums/account-types'>,
  ENUMS_BANK_METHODS: '/enums/bank-methods' as TypedPath<'/enums/bank-methods'>,
  ENUMS_BENEFICIARY_RELATIONSHIP_TYPES: '/enums/beneficiary-relationship-types' as TypedPath<'/enums/beneficiary-relationship-types'>,
  ENUMS_BUSINESS_ENTITY_TYPES: '/enums/business-entity-types' as TypedPath<'/enums/business-entity-types'>,
  ENUMS_CHECK_WRITINGS: '/enums/check-writings' as TypedPath<'/enums/check-writings'>,
  ENUMS_CLAIM_APPROVAL_STATUS_CODE: '/enums/claim-approval-status-code' as TypedPath<'/enums/claim-approval-status-code'>,
  ENUMS_CLAIM_STATUS: '/enums/claim-status' as TypedPath<'/enums/claim-status'>,
  ENUMS_COUNTRIES: '/enums/countries' as TypedPath<'/enums/countries'>,
  ENUMS_ELECTRONIC_FUNDING_REPLENISHMENTS: '/enums/electronic-funding-replenishments' as TypedPath<'/enums/electronic-funding-replenishments'>,
  ENUMS_ELIGIBLE_DEPENDENTS: '/enums/eligible-dependents' as TypedPath<'/enums/eligible-dependents'>,
  ENUMS_FREQUENCIES: '/enums/frequencies' as TypedPath<'/enums/frequencies'>,
  ENUMS_HSA_CUSTODIAN_CONFIGS: '/enums/hsa-custodian-configs' as TypedPath<'/enums/hsa-custodian-configs'>,
  ENUMS_HSA_CUSTODIANS: '/enums/hsa-custodians' as TypedPath<'/enums/hsa-custodians'>,
  ENUMS_LOCK_REASONS: '/enums/lock-reasons' as TypedPath<'/enums/lock-reasons'>,
  ENUMS_OVERRIDABLE_PROPERTIES_FIELD_STATE: '/enums/overridable-properties-field-state' as TypedPath<'/enums/overridable-properties-field-state'>,
  ENUMS_PAYOUT_RULES: '/enums/payout-rules' as TypedPath<'/enums/payout-rules'>,
  ENUMS_PROOF_OF_EXPENSES: '/enums/proof-of-expenses' as TypedPath<'/enums/proof-of-expenses'>,
  ENUMS_RELATIONSHIP_TYPES: '/enums/relationship-types' as TypedPath<'/enums/relationship-types'>,
  ENUMS_SERVICE_CATEGORIES: '/enums/service-categories' as TypedPath<'/enums/service-categories'>,
  ENUMS_SOURCE_IDS: '/enums/source-ids' as TypedPath<'/enums/source-ids'>,
  ENUMS_STATES: '/enums/states' as TypedPath<'/enums/states'>,
  ENUMS_STATUSES: '/enums/statuses' as TypedPath<'/enums/statuses'>,
  ENUMS_TRIGGERS: '/enums/triggers' as TypedPath<'/enums/triggers'>,
  EOY_PLAN_RECONCILIATIONS_APPROVE: '/eoy-plan-reconciliations/approve' as TypedPath<'/eoy-plan-reconciliations/approve'>,
  EOY_PLAN_RECONCILIATIONS_INVOICES_BY_INVOICE_ID: (invoice_id: string | number) => `/eoy-plan-reconciliations/invoices/${invoice_id}` as TypedPath<'/eoy-plan-reconciliations/invoices/{invoice_id}'>,
  EXPENSES: '/expenses' as TypedPath<'/expenses'>,
  EXPENSES_STATISTICS: '/expenses/statistics' as TypedPath<'/expenses/statistics'>,
  EXPRESS_SETUP_CONTACTS: '/express-setup/contacts' as TypedPath<'/express-setup/contacts'>,
  EXPRESS_SETUP_ENABLED: '/express-setup/enabled' as TypedPath<'/express-setup/enabled'>,
  EXPRESS_SETUPS: '/express-setups' as TypedPath<'/express-setups'>,
  EXPRESS_SETUPS_BY_ORGANIZATION_ID: (organizationId: string | number) => `/express-setups/${organizationId}` as TypedPath<'/express-setups/{organization-id}'>,
  EXPRESS_SETUPS_STATUS_BY_ORGANIZATION_ID: (organizationId: string | number) => `/express-setups/${organizationId}/status` as TypedPath<'/express-setups/{organization-id}/status'>,
  EXTERNAL_TEMPLATES: '/external-templates' as TypedPath<'/external-templates'>,
  EXTERNAL_TEMPLATES_AVAILABLE: '/external-templates/available' as TypedPath<'/external-templates/available'>,
  EXTERNAL_TEMPLATES_HTML_PREVIEW_BY_ID: (id: string | number) => `/external-templates/${id}/html-preview` as TypedPath<'/external-templates/{id}/html-preview'>,
  EXTERNAL_TEMPLATES_SMS_PREVIEW_BY_ID: (id: string | number) => `/external-templates/${id}/sms-preview` as TypedPath<'/external-templates/{id}/sms-preview'>,
  EXTERNAL_TEMPLATES_VARIABLES_BY_ID: (id: string | number) => `/external-templates/${id}/variables` as TypedPath<'/external-templates/{id}/variables'>,
  FEE_REVERSAL: '/fee/reversal' as TypedPath<'/fee/reversal'>,
  FEE_TRANSFER: '/fee/transfer' as TypedPath<'/fee/transfer'>,
  FILE_STATUS_EVENT_STREAM: '/file-status-event/stream' as TypedPath<'/file-status-event/stream'>,
  FILE_APPROVE_BY_FILE_ID: (fileId: string | number) => `/file/approve/${fileId}` as TypedPath<'/file/approve/{file-id}'>,
  FILE_CANCEL_BY_FILE_ID: (fileId: string | number) => `/file/cancel/${fileId}` as TypedPath<'/file/cancel/{file-id}'>,
  FILE_FILE_LINK_BY_FILE_ID: (fileId: string | number) => `/file/file-link/${fileId}` as TypedPath<'/file/file-link/{file-id}'>,
  FILE_FILES: '/file/files' as TypedPath<'/file/files'>,
  FILE_FILES_BY_FILE_ID: (fileId: string | number) => `/file/files/${fileId}` as TypedPath<'/file/files/{file-id}'>,
  FILE_FILES_DETAILS_BY_FILE_ID: (fileId: string | number) => `/file/files/${fileId}/details` as TypedPath<'/file/files/{file-id}/details'>,
  FILE_FILES_ERRORS_BY_FILE_ID: (fileId: string | number) => `/file/files/${fileId}/errors` as TypedPath<'/file/files/{file-id}/errors'>,
  FILE_FILES_ERRORS_CSV_BY_FILE_ID: (fileId: string | number) => `/file/files/${fileId}/errors-csv` as TypedPath<'/file/files/{file-id}/errors-csv'>,
  FILE_FILES_RECORDS_BY_FILE_ID: (fileId: string | number) => `/file/files/${fileId}/records` as TypedPath<'/file/files/{file-id}/records'>,
  FILE_FILES_RECORDS_ERRORS_BY_FILE_ID: (fileId: string | number) => `/file/files/${fileId}/records/errors` as TypedPath<'/file/files/{file-id}/records/errors'>,
  FILE_PROCESS_DUPLICATE_BY_FILE_ID: (fileId: string | number) => `/file/process-duplicate/${fileId}` as TypedPath<'/file/process-duplicate/{file-id}'>,
  FILE_BY_FILE_ID: (fileId: string | number) => `/file/${fileId}` as TypedPath<'/file/{file-id}'>,
  FILE_REPROCESS_RECORDS_BY_FILE_ID: (fileId: string | number) => `/file/${fileId}/reprocess-records` as TypedPath<'/file/{file-id}/reprocess-records'>,
  FILES_SEARCH: '/files-search' as TypedPath<'/files-search'>,
  FILES_CSV_IMPORT: '/files/csv/import' as TypedPath<'/files/csv/import'>,
  FILES_FILE_ACTORS: '/files/file-actors' as TypedPath<'/files/file-actors'>,
  FORGOT_PASSWORD: '/forgot-password' as TypedPath<'/forgot-password'>,
  HEALTH_PLANS: '/health-plans' as TypedPath<'/health-plans'>,
  HEALTH_PLANS_ENROLLMENTS: '/health-plans-enrollments' as TypedPath<'/health-plans-enrollments'>,
  HEALTH_PLANS_HEALTH_POLICIES: '/health-plans/health-policies' as TypedPath<'/health-plans/health-policies'>,
  HEALTH_PLANS_HEALTH_POLICIES_EXISTS: '/health-plans/health-policies/exists' as TypedPath<'/health-plans/health-policies/exists'>,
  HEALTH_PLANS_TEMPLATES: '/health-plans/templates' as TypedPath<'/health-plans/templates'>,
  HEALTH_PLANS_BY_HEALTH_PLAN_ID: (healthPlanId: string | number) => `/health-plans/${healthPlanId}` as TypedPath<'/health-plans/{health-plan-id}'>,
  HEALTH_PLANS_BY_ID: (id: string | number) => `/health-plans/${id}` as TypedPath<'/health-plans/{id}'>,
  HEALTH_PLANS_NOTES_BY_ID: (id: string | number) => `/health-plans/${id}/notes` as TypedPath<'/health-plans/{id}/notes'>,
  IDI_ASSET_DETAILS_BY_ASSET_ID_CORRELATION_ID: (assetId: string | number, correlationId: string | number) => `/idi/asset-details/${assetId}/${correlationId}` as TypedPath<'/idi/asset-details/{asset-id}/{correlation-id}'>,
  IDOLOGY_CHALLENGE: '/idology/challenge' as TypedPath<'/idology/challenge'>,
  IDOLOGY_CHALLENGE_ANSWERS: '/idology/challenge-answers' as TypedPath<'/idology/challenge-answers'>,
  IDOLOGY_DOCUMENT_PROCESS_STATUS: '/idology/document-process-status' as TypedPath<'/idology/document-process-status'>,
  IDOLOGY_IDENTIFICATION: '/idology/identification' as TypedPath<'/idology/identification'>,
  IDOLOGY_QUESTIONNAIRE_ANSWERS: '/idology/questionnaire-answers' as TypedPath<'/idology/questionnaire-answers'>,
  INSTRUMENTS_CATEGORIES: '/instruments/categories' as TypedPath<'/instruments/categories'>,
  INSTRUMENTS_CURRENT_INVESTOR_ACCOUNT: '/instruments/current-investor-account' as TypedPath<'/instruments/current-investor-account'>,
  INSTRUMENTS_SELF_DIRECTED: '/instruments/self-directed' as TypedPath<'/instruments/self-directed'>,
  INTEREST_RATE_TEMPLATES_ACTIVE: '/interest-rate-templates/active' as TypedPath<'/interest-rate-templates/active'>,
  INTEREST_RATE_TEMPLATES_BY_TEMPLATE_ID: (templateId: string | number) => `/interest-rate-templates/${templateId}` as TypedPath<'/interest-rate-templates/{template-id}'>,
  INTEREST_RATE_TEMPLATES_VERSIONS_LATEST_BY_TEMPLATE_ID: (templateId: string | number) => `/interest-rate-templates/${templateId}/versions/latest` as TypedPath<'/interest-rate-templates/{template-id}/versions/latest'>,
  INTEREST_RATE_TEMPLATES_VERSIONS_BY_TEMPLATE_ID_VERSION_ID: (templateId: string | number, versionId: string | number) => `/interest-rate-templates/${templateId}/versions/${versionId}` as TypedPath<'/interest-rate-templates/{template-id}/versions/{version-id}'>,
  INVESTMENT_PORTFOLIOS_PROPOSED: '/investment-portfolios/proposed' as TypedPath<'/investment-portfolios/proposed'>,
  INVESTMENT_SCHEDULERS: '/investment-schedulers' as TypedPath<'/investment-schedulers'>,
  INVESTMENT_SCHEDULERS_BY_ID: (id: string | number) => `/investment-schedulers/${id}` as TypedPath<'/investment-schedulers/{id}'>,
  INVESTMENTS_FLOWS_APPROVE: '/investments/flows/approve' as TypedPath<'/investments/flows/approve'>,
  INVESTMENTS_FLOWS_FUNDING: '/investments/flows/funding' as TypedPath<'/investments/flows/funding'>,
  INVESTMENTS_FLOWS_PATH: '/investments/flows/path' as TypedPath<'/investments/flows/path'>,
  INVESTMENTS_FLOWS_QUESTIONNAIRE: '/investments/flows/questionnaire' as TypedPath<'/investments/flows/questionnaire'>,
  INVESTMENTS_FLOWS_START: '/investments/flows/start' as TypedPath<'/investments/flows/start'>,
  INVESTMENTS_HOLDINGS: '/investments/holdings' as TypedPath<'/investments/holdings'>,
  INVESTMENTS_INVESTMENT_STATUS: '/investments/investment-status' as TypedPath<'/investments/investment-status'>,
  INVESTORS: '/investors' as TypedPath<'/investors'>,
  INVESTORS_BASE: '/investors/base' as TypedPath<'/investors/base'>,
  INVESTORS_INVESTMENT_MODELS: '/investors/investment-models' as TypedPath<'/investors/investment-models'>,
  INVESTORS_PERFORMANCE_PNL: '/investors/performance/pnl' as TypedPath<'/investors/performance/pnl'>,
  INVESTORS_RISK_TOLERANCE_MODEL_BY_ID: (id: string | number) => `/investors/${id}/risk-tolerance-model` as TypedPath<'/investors/{id}/risk-tolerance-model'>,
  INVOICES_APPLY_UNMATCHED: '/invoices/apply-unmatched' as TypedPath<'/invoices/apply-unmatched'>,
  INVOICES_DASHBOARD: '/invoices/dashboard' as TypedPath<'/invoices/dashboard'>,
  INVOICES_SEARCH_UNAPPLIED_PUSH: '/invoices/search-unapplied-push' as TypedPath<'/invoices/search-unapplied-push'>,
  INVOICES_DETAILS_VIEW_BY_INVOICE_ID: (invoiceId: string | number) => `/invoices/${invoiceId}/details-view` as TypedPath<'/invoices/{invoice-id}/details-view'>,
  IRS_MAXIMUMS: '/irs-maximums' as TypedPath<'/irs-maximums'>,
  IRS_MAXIMUMS_EMPLOYEE_BY_EMPLOYEE_ID: (employeeId: string | number) => `/irs-maximums/employee/${employeeId}` as TypedPath<'/irs-maximums/employee/{employee-id}'>,
  IRS_MAXIMUMS_TYPES: '/irs-maximums/types' as TypedPath<'/irs-maximums/types'>,
  LETTERS_OF_MEDICAL_NECESSITY: '/letters-of-medical-necessity' as TypedPath<'/letters-of-medical-necessity'>,
  LETTERS_OF_MEDICAL_NECESSITY_BY_ID: (id: string | number) => `/letters-of-medical-necessity/${id}` as TypedPath<'/letters-of-medical-necessity/{id}'>,
  LOCKBOXES: '/lockboxes' as TypedPath<'/lockboxes'>,
  LOCKBOXES_CLAIM_REPAYMENT_BY_LOCKBOX_ID: (lockboxId: string | number) => `/lockboxes/claim-repayment/${lockboxId}` as TypedPath<'/lockboxes/claim-repayment/{lockbox-id}'>,
  LOCKBOXES_MATCHED_EMPLOYEES_BY_EMPLOYEE_ID: (employeeId: string | number) => `/lockboxes/matched-employees/${employeeId}` as TypedPath<'/lockboxes/matched-employees/{employee-id}'>,
  LOCKBOXES_RETURNED_CHECKS_PROCESSING_DECISIONS: '/lockboxes/returned-checks/processing-decisions' as TypedPath<'/lockboxes/returned-checks/processing-decisions'>,
  LOCKBOXES_RETURNED_ITEMS: '/lockboxes/returned-items' as TypedPath<'/lockboxes/returned-items'>,
  LOCKBOXES_BY_LOCKBOX_ID: (lockboxId: string | number) => `/lockboxes/${lockboxId}` as TypedPath<'/lockboxes/{lockbox-id}'>,
  LOCKBOXES_CHECK_DETAILS_BY_LOCKBOX_ID: (lockboxId: string | number) => `/lockboxes/${lockboxId}/check-details` as TypedPath<'/lockboxes/{lockbox-id}/check-details'>,
  LOCKBOXES_SPLITTING_BY_LOCKBOX_ID: (lockboxId: string | number) => `/lockboxes/${lockboxId}/splitting` as TypedPath<'/lockboxes/{lockbox-id}/splitting'>,
  LOGIN_HISTORY_ADMIN: '/login-history/admin' as TypedPath<'/login-history/admin'>,
  LOGIN_HISTORY_EMPLOYEE: '/login-history/employee' as TypedPath<'/login-history/employee'>,
  LOGIN_LOCK: '/login/lock' as TypedPath<'/login/lock'>,
  LOGIN_UNLOCK: '/login/unlock' as TypedPath<'/login/unlock'>,
  MAINTENANCE_CARD: '/maintenance/card' as TypedPath<'/maintenance/card'>,
  MANUAL_CONTRIBUTION: '/manual-contribution' as TypedPath<'/manual-contribution'>,
  MANUAL_CONTRIBUTION_COVERAGE_PERIODS: '/manual-contribution/coverage-periods' as TypedPath<'/manual-contribution/coverage-periods'>,
  MANUAL_CONTRIBUTION_EMPLOYEES: '/manual-contribution/employees' as TypedPath<'/manual-contribution/employees'>,
  MANUAL_CONTRIBUTION_EMPLOYEES_COUNT: '/manual-contribution/employees/count' as TypedPath<'/manual-contribution/employees/count'>,
  METRICS_ACCOUNT_USAGE_PLAN_YEARS: '/metrics/account-usage/plan-years' as TypedPath<'/metrics/account-usage/plan-years'>,
  METRICS_ACCOUNT_USAGE_TOTAL_CLAIM_SPEND: '/metrics/account-usage/total-claim-spend' as TypedPath<'/metrics/account-usage/total-claim-spend'>,
  METRICS_CIP_CONFIG: '/metrics/cip-config' as TypedPath<'/metrics/cip-config'>,
  METRICS_CIP_INFO: '/metrics/cip-info' as TypedPath<'/metrics/cip-info'>,
  METRICS_CLAIMS_SUBSTANTIATION_RATE: '/metrics/claims-substantiation-rate' as TypedPath<'/metrics/claims-substantiation-rate'>,
  METRICS_DELINQUENT_CLAIMS: '/metrics/delinquent-claims' as TypedPath<'/metrics/delinquent-claims'>,
  METRICS_EMPLOYEES: '/metrics/employees' as TypedPath<'/metrics/employees'>,
  METRICS_EMPLOYER_CALENDAR_EVENTS: '/metrics/employer-calendar-events' as TypedPath<'/metrics/employer-calendar-events'>,
  METRICS_FRAUD_REVIEW_REQUIRED: '/metrics/fraud-review-required' as TypedPath<'/metrics/fraud-review-required'>,
  METRICS_INVOICE_PLAN_LEVEL_REPLENISHMENT: '/metrics/invoice-plan-level-replenishment' as TypedPath<'/metrics/invoice-plan-level-replenishment'>,
  METRICS_INVOICE_REPLENISHMENT: '/metrics/invoice-replenishment' as TypedPath<'/metrics/invoice-replenishment'>,
  METRICS_PLAN_ENROLLMENT: '/metrics/plan-enrollment' as TypedPath<'/metrics/plan-enrollment'>,
  METRICS_UNDELIVERABLE_MAIL: '/metrics/undeliverable-mail' as TypedPath<'/metrics/undeliverable-mail'>,
  MFA_CODES: '/mfa/codes' as TypedPath<'/mfa/codes'>,
  MFA_CODES_VERIFICATIONS: '/mfa/codes/verifications' as TypedPath<'/mfa/codes/verifications'>,
  MFA_UNLOCK: '/mfa/unlock' as TypedPath<'/mfa/unlock'>,
  MOBILE_APP_FEEDBACK: '/mobile-app/feedback' as TypedPath<'/mobile-app/feedback'>,
  MOBILE_APP_FEEDBACK_CONFIG: '/mobile-app/feedback/config' as TypedPath<'/mobile-app/feedback/config'>,
  MOBILE_APP_PROBLEM_REPORT: '/mobile-app/problem-report' as TypedPath<'/mobile-app/problem-report'>,
  MOBILE_THEMES: '/mobile-themes' as TypedPath<'/mobile-themes'>,
  MONEY_TRANSFERS: '/money-transfers' as TypedPath<'/money-transfers'>,
  MONITOR_CONTRIBUTION_INFO: '/monitor-contribution/info' as TypedPath<'/monitor-contribution/info'>,
  MP_TABLES: '/mp-tables' as TypedPath<'/mp-tables'>,
  OAUTH2_TOKEN: '/oauth2/token' as TypedPath<'/oauth2/token'>,
  OMNI_BALANCES_ORGANIZATIONS_BY_ORG_ID: (orgId: string | number) => `/omni-balances/organizations/${orgId}` as TypedPath<'/omni-balances/organizations/{org-id}'>,
  OMNI_BALANCES_ORGANIZATIONS_DETAILS_BY_ORG_ID: (orgId: string | number) => `/omni-balances/organizations/${orgId}/details` as TypedPath<'/omni-balances/organizations/{org-id}/details'>,
  OMNI_BALANCES_ORGANIZATIONS_CHILDREN_BY_PARENT_ORG_ID: (parentOrgId: string | number) => `/omni-balances/organizations/${parentOrgId}/children` as TypedPath<'/omni-balances/organizations/{parent-org-id}/children'>,
  ORDERS: '/orders' as TypedPath<'/orders'>,
  ORGANIZATION_LOCKS_LOCK_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organization-locks/lock/${organizationId}` as TypedPath<'/organization-locks/lock/{organization-id}'>,
  ORGANIZATION_LOCKS_UNLOCK_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organization-locks/unlock/${organizationId}` as TypedPath<'/organization-locks/unlock/{organization-id}'>,
  ORGANIZATION_LOCKS_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organization-locks/${organizationId}` as TypedPath<'/organization-locks/{organizationId}'>,
  ORGANIZATION_PROPERTIES_STATE_CONFIGS: '/organization-properties-state-configs' as TypedPath<'/organization-properties-state-configs'>,
  ORGANIZATION_PROPERTIES_STATE_CONFIGS_BY_ID: (id: string | number) => `/organization-properties-state-configs/${id}` as TypedPath<'/organization-properties-state-configs/{id}'>,
  ORGANIZATION_PROPERTIES_STATES: '/organization-properties-states' as TypedPath<'/organization-properties-states'>,
  ORGANIZATION_PROPERTIES_HASH_BY_HASH_ID: (hashId: string | number) => `/organization-properties/hash/${hashId}` as TypedPath<'/organization-properties/hash/{hash-id}'>,
  ORGANIZATIONS: '/organizations' as TypedPath<'/organizations'>,
  ORGANIZATIONS_ACCOUNT_MANAGER_BY_ACCOUNT_MANAGER_ID: (accountManagerId: string | number) => `/organizations/account-manager/${accountManagerId}` as TypedPath<'/organizations/account-manager/{account-manager-id}'>,
  ORGANIZATIONS_CLAIMS_TEAM_HIERARCHY_BY_CLAIMS_TEAM_ID: (claimsTeamId: string | number) => `/organizations/claims-team/${claimsTeamId}/hierarchy` as TypedPath<'/organizations/claims-team/{claims-team-id}/hierarchy'>,
  ORGANIZATIONS_EXTERNAL_ID_BY_EXTERNAL_ID: (externalId: string | number) => `/organizations/external-id/${externalId}` as TypedPath<'/organizations/external-id/{external-id}'>,
  ORGANIZATIONS_HIERARCHY: '/organizations/hierarchy' as TypedPath<'/organizations/hierarchy'>,
  ORGANIZATIONS_LOGO: '/organizations/logo' as TypedPath<'/organizations/logo'>,
  ORGANIZATIONS_LOGO_EMAIL_TEMPLATES: '/organizations/logo/email-templates' as TypedPath<'/organizations/logo/email-templates'>,
  ORGANIZATIONS_NAMES: '/organizations/names' as TypedPath<'/organizations/names'>,
  ORGANIZATIONS_ORPHAN: '/organizations/orphan' as TypedPath<'/organizations/orphan'>,
  ORGANIZATIONS_OVERRIDABLE_PROPERTIES_BY_ONE_TIME_LINKS_BY_HASH_ID: (hashId: string | number) => `/organizations/overridable-properties/by-one-time-links/${hashId}` as TypedPath<'/organizations/overridable-properties/by-one-time-links/{hash-id}'>,
  ORGANIZATIONS_OVERRIDABLE_PROPERTIES_BY_QR_CODES_BY_QR_ID: (qrId: string | number) => `/organizations/overridable-properties/by-qr-codes/${qrId}` as TypedPath<'/organizations/overridable-properties/by-qr-codes/{qr-id}'>,
  ORGANIZATIONS_SHORT: '/organizations/short' as TypedPath<'/organizations/short'>,
  ORGANIZATIONS_SUBSIDIARIES: '/organizations/subsidiaries' as TypedPath<'/organizations/subsidiaries'>,
  ORGANIZATIONS_NAME_BY_ID: (id: string | number) => `/organizations/${id}/name` as TypedPath<'/organizations/{id}/name'>,
  ORGANIZATIONS_SHORT_BY_ID: (id: string | number) => `/organizations/${id}/short` as TypedPath<'/organizations/{id}/short'>,
  ORGANIZATIONS_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}` as TypedPath<'/organizations/{organization-id}'>,
  ORGANIZATIONS_ACCOUNTS_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}/accounts` as TypedPath<'/organizations/{organization-id}/accounts'>,
  ORGANIZATIONS_ACTIVATE_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}/activate` as TypedPath<'/organizations/{organization-id}/activate'>,
  ORGANIZATIONS_ADDRESSES_BY_ORGANIZATION_ID_ADDRESS_ID: (organizationId: string | number, addressId: string | number) => `/organizations/${organizationId}/addresses/${addressId}` as TypedPath<'/organizations/{organization-id}/addresses/{address-id}'>,
  ORGANIZATIONS_EMPLOYEE_VALIDATION_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}/employee-validation` as TypedPath<'/organizations/{organization-id}/employee-validation'>,
  ORGANIZATIONS_EMPLOYEE_VIEW_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}/employee-view` as TypedPath<'/organizations/{organization-id}/employee-view'>,
  ORGANIZATIONS_NOTES_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}/notes` as TypedPath<'/organizations/{organization-id}/notes'>,
  ORGANIZATIONS_NOTIFICATION_PROPERTIES_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}/notification-properties` as TypedPath<'/organizations/{organization-id}/notification-properties'>,
  ORGANIZATIONS_OVERRIDABLE_PROPERTIES_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}/overridable-properties` as TypedPath<'/organizations/{organization-id}/overridable-properties'>,
  ORGANIZATIONS_OVERRIDABLE_PROPERTIES_EMPLOYEE_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}/overridable-properties/employee` as TypedPath<'/organizations/{organization-id}/overridable-properties/employee'>,
  ORGANIZATIONS_OVERRIDABLE_PROPERTIES_PROPAGATE_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}/overridable-properties/propagate` as TypedPath<'/organizations/{organization-id}/overridable-properties/propagate'>,
  ORGANIZATIONS_OVERRIDABLE_PROPERTIES_VALIDATE_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}/overridable-properties/validate` as TypedPath<'/organizations/{organization-id}/overridable-properties/validate'>,
  ORGANIZATIONS_PHONES_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}/phones` as TypedPath<'/organizations/{organization-id}/phones'>,
  ORGANIZATIONS_PHONES_BY_ORGANIZATION_ID_PHONE_ID: (organizationId: string | number, phoneId: string | number) => `/organizations/${organizationId}/phones/${phoneId}` as TypedPath<'/organizations/{organization-id}/phones/{phone-id}'>,
  ORGANIZATIONS_PROPERTIES_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}/properties` as TypedPath<'/organizations/{organization-id}/properties'>,
  ORGANIZATIONS_REACTIVATION_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}/reactivation` as TypedPath<'/organizations/{organization-id}/reactivation'>,
  ORGANIZATIONS_STATUSES_BY_ORGANIZATION_ID_STATUS: (organizationId: string | number, status: string | number) => `/organizations/${organizationId}/statuses/${status}` as TypedPath<'/organizations/{organization-id}/statuses/{status}'>,
  ORGANIZATIONS_TERMINATION_BY_ORGANIZATION_ID: (organizationId: string | number) => `/organizations/${organizationId}/termination` as TypedPath<'/organizations/{organization-id}/termination'>,
  PASSWORD_RESET_VALIDATION: '/password/reset/validation' as TypedPath<'/password/reset/validation'>,
  PASSWORDS: '/passwords' as TypedPath<'/passwords'>,
  PASSWORDS_RESET: '/passwords/reset' as TypedPath<'/passwords/reset'>,
  PAYMENT_ACCOUNT: '/payment-account' as TypedPath<'/payment-account'>,
  PAYMENT_METHODS: '/payment-methods' as TypedPath<'/payment-methods'>,
  PAYMENT_METHODS_DEBIT_CARD: '/payment-methods/debit-card' as TypedPath<'/payment-methods/debit-card'>,
  PAYMENT_METHODS_RECIPIENT: '/payment-methods/recipient' as TypedPath<'/payment-methods/recipient'>,
  PAYMENT_METHODS_BY_ID: (id: string | number) => `/payment-methods/${id}` as TypedPath<'/payment-methods/{id}'>,
  PAYMENT_METHODS_CARD_BY_ID: (id: string | number) => `/payment-methods/${id}/card` as TypedPath<'/payment-methods/{id}/card'>,
  PAYOUT_DEFINITIONS: '/payout-definitions' as TypedPath<'/payout-definitions'>,
  PAYOUT_DEFINITIONS_LITE: '/payout-definitions/lite' as TypedPath<'/payout-definitions/lite'>,
  PAYOUT_DEFINITIONS_BY_ID: (id: string | number) => `/payout-definitions/${id}` as TypedPath<'/payout-definitions/{id}'>,
  PAYOUT_DEFINITIONS_PLANS_BY_ID: (id: string | number) => `/payout-definitions/${id}/plans` as TypedPath<'/payout-definitions/{id}/plans'>,
  PAYOUT_DEFINITIONS_SERVICES_BY_ID: (id: string | number) => `/payout-definitions/${id}/services` as TypedPath<'/payout-definitions/{id}/services'>,
  PAYROLL_CALENDARS: '/payroll-calendars' as TypedPath<'/payroll-calendars'>,
  PAYROLL_CALENDARS_CALCULATE_SCHEDULE: '/payroll-calendars/calculate-schedule' as TypedPath<'/payroll-calendars/calculate-schedule'>,
  PAYROLL_CALENDARS_ORGANIZATIONS_ORGANIZATION_PATH_REDUCED: '/payroll-calendars/organizations/organization-path/reduced' as TypedPath<'/payroll-calendars/organizations/organization-path/reduced'>,
  PAYROLL_CALENDARS_ORGANIZATIONS_REDUCED_BY_ID: (id: string | number) => `/payroll-calendars/organizations/${id}/reduced` as TypedPath<'/payroll-calendars/organizations/{id}/reduced'>,
  PAYROLL_CALENDARS_ORGANIZATIONS_BY_ORGANIZATION_ID: (organizationId: string | number) => `/payroll-calendars/organizations/${organizationId}` as TypedPath<'/payroll-calendars/organizations/{organization-id}'>,
  PAYROLL_CALENDARS_PARTNER: '/payroll-calendars/partner' as TypedPath<'/payroll-calendars/partner'>,
  PAYROLL_CALENDARS_PARTNER_BY_CALENDAR_ID: (calendarId: string | number) => `/payroll-calendars/${calendarId}/partner` as TypedPath<'/payroll-calendars/{calendar-id}/partner'>,
  PAYROLL_CALENDARS_BY_ID: (id: string | number) => `/payroll-calendars/${id}` as TypedPath<'/payroll-calendars/{id}'>,
  PAYROLL_CALENDARS_SCHEDULED_DATES_BY_ID: (id: string | number) => `/payroll-calendars/${id}/scheduled-dates` as TypedPath<'/payroll-calendars/{id}/scheduled-dates'>,
  PAYROLL_GROUPS: '/payroll-groups' as TypedPath<'/payroll-groups'>,
  PAYROLL_GROUPS_ORGANIZATIONS_BY_ORG_ID: (orgId: string | number) => `/payroll-groups/organizations/${orgId}` as TypedPath<'/payroll-groups/organizations/{org-id}'>,
  PAYROLL_GROUPS_BY_ID: (id: string | number) => `/payroll-groups/${id}` as TypedPath<'/payroll-groups/{id}'>,
  PERFORMANCE_HISTORIES: '/performance-histories' as TypedPath<'/performance-histories'>,
  PERMISSIONS: '/permissions' as TypedPath<'/permissions'>,
  PERMISSIONS_ALL: '/permissions/all' as TypedPath<'/permissions/all'>,
  PERSON_SPEND_LIMITS: '/person-spend-limits' as TypedPath<'/person-spend-limits'>,
  PERSONS_FORGOT_PASSWORD: '/persons/forgot-password' as TypedPath<'/persons/forgot-password'>,
  PERSONS_USERNAMES_FORGOT: '/persons/usernames/forgot' as TypedPath<'/persons/usernames/forgot'>,
  PERSONS_BY_PERSON_ID: (personId: string | number) => `/persons/${personId}` as TypedPath<'/persons/{person-id}'>,
  PLAID_EXCHANGE_TOKEN: '/plaid/exchange-token' as TypedPath<'/plaid/exchange-token'>,
  PLAID_LINK_TOKEN: '/plaid/link-token' as TypedPath<'/plaid/link-token'>,
  PLAN_ACCOUNT_FUNDING_CONFIG_PLAN_LEVEL_FUNDING: '/plan-account-funding-config/plan-level-funding' as TypedPath<'/plan-account-funding-config/plan-level-funding'>,
  PLAN_ACCOUNT_FUNDING_CONFIG_PLAN_LEVEL_FUNDING_ORGANIZATIONS: '/plan-account-funding-config/plan-level-funding/organizations' as TypedPath<'/plan-account-funding-config/plan-level-funding/organizations'>,
  PLAN_OMNI_BALANCES_HISTORY: '/plan-omni-balances/history' as TypedPath<'/plan-omni-balances/history'>,
  PLAN_YEARS: '/plan-years' as TypedPath<'/plan-years'>,
  PLAN_YEARS_HEALTH_PLANS: '/plan-years/health-plans' as TypedPath<'/plan-years/health-plans'>,
  PLAN_YEARS_LIST: '/plan-years/list' as TypedPath<'/plan-years/list'>,
  PLAN_YEARS_PRIORS: '/plan-years/priors' as TypedPath<'/plan-years/priors'>,
  PLAN_YEARS_BY_ID: (id: string | number) => `/plan-years/${id}` as TypedPath<'/plan-years/{id}'>,
  PLAN_YEARS_PLANS_BY_ID: (id: string | number) => `/plan-years/${id}/plans` as TypedPath<'/plan-years/{id}/plans'>,
  PLAN_YEARS_BY_PLAN_YEAR_ID: (planYearId: string | number) => `/plan-years/${planYearId}` as TypedPath<'/plan-years/{plan-year-id}'>,
  PLANS: '/plans' as TypedPath<'/plans'>,
  PLANS_ACCOUNTS: '/plans/accounts' as TypedPath<'/plans/accounts'>,
  PLANS_ORGANIZATIONS_ACTIVE_GRACE_PERIOD_BY_ORGANIZATION_ID: (organizationId: string | number) => `/plans/organizations/${organizationId}/active-grace-period` as TypedPath<'/plans/organizations/{organization-id}/active-grace-period'>,
  PLANS_ORGANIZATIONS_REACTIVATION_ELIGIBLE_BY_ORGANIZATION_ID: (organizationId: string | number) => `/plans/organizations/${organizationId}/reactivation-eligible` as TypedPath<'/plans/organizations/{organization-id}/reactivation-eligible'>,
  PLANS_PLAN_CODES_VALIDATIONS: '/plans/plan-codes/validations' as TypedPath<'/plans/plan-codes/validations'>,
  PLANS_PLAN_PRIMARY_CONFIG: '/plans/plan-primary-config' as TypedPath<'/plans/plan-primary-config'>,
  PLANS_PRIORS: '/plans/priors' as TypedPath<'/plans/priors'>,
  PLANS_REACTIVATION: '/plans/reactivation' as TypedPath<'/plans/reactivation'>,
  PLANS_REACTIVATION_ELIGIBILITY: '/plans/reactivation-eligibility' as TypedPath<'/plans/reactivation-eligibility'>,
  PLANS_SERVICES: '/plans/services' as TypedPath<'/plans/services'>,
  PLANS_TEMPLATE_ASSIGNED: '/plans/template-assigned' as TypedPath<'/plans/template-assigned'>,
  PLANS_TERMINATION_PROPERTIES: '/plans/termination-properties' as TypedPath<'/plans/termination-properties'>,
  PLANS_NOTES_BY_ID: (id: string | number) => `/plans/${id}/notes` as TypedPath<'/plans/{id}/notes'>,
  PLANS_BY_PLAN_ID: (planId: string | number) => `/plans/${planId}` as TypedPath<'/plans/{plan-id}'>,
  PLANS_ACTIVE_GRACE_PERIOD_BY_PLAN_ID: (planId: string | number) => `/plans/${planId}/active-grace-period` as TypedPath<'/plans/{plan-id}/active-grace-period'>,
  PLANS_ELECTION_AMOUNT_BY_PLAN_ID: (planId: string | number) => `/plans/${planId}/election-amount` as TypedPath<'/plans/{plan-id}/election-amount'>,
  PLANS_HEALTH_PLAN_TIER_STATS_BY_PLAN_ID: (planId: string | number) => `/plans/${planId}/health-plan-tier-stats` as TypedPath<'/plans/{plan-id}/health-plan-tier-stats'>,
  PLANS_SERVICES_BY_PLAN_ID: (planId: string | number) => `/plans/${planId}/services` as TypedPath<'/plans/{plan-id}/services'>,
  PLANS_TERMINATION_PROPERTIES_BY_PLAN_ID: (planId: string | number) => `/plans/${planId}/termination-properties` as TypedPath<'/plans/{plan-id}/termination-properties'>,
  POLICIES: '/policies' as TypedPath<'/policies'>,
  POLICIES_ACCOUNTS: '/policies/accounts' as TypedPath<'/policies/accounts'>,
  POLICIES_BALANCE_REMINDER: '/policies/balance-reminder' as TypedPath<'/policies/balance-reminder'>,
  POLICIES_FUND_ID: '/policies/fund-id' as TypedPath<'/policies/fund-id'>,
  POLICIES_REDUCED: '/policies/reduced' as TypedPath<'/policies/reduced'>,
  POLICIES_ELECTIONS_BY_POLICY_ID_ELECTION_ID: (policyId: string | number, electionId: string | number) => `/policies/${policyId}/elections/${electionId}` as TypedPath<'/policies/{policy-id}/elections/{election-id}'>,
  POLICIES_LIMITS_BY_POLICY_ID: (policyId: string | number) => `/policies/${policyId}/limits` as TypedPath<'/policies/{policy-id}/limits'>,
  POLICIES_STATUSES_BY_POLICY_ID_STATUS_ID: (policyId: string | number, statusId: string | number) => `/policies/${policyId}/statuses/${statusId}` as TypedPath<'/policies/{policy-id}/statuses/{status-id}'>,
  POLICIES_POLICY_STATUSES_BY_POLICY_ID: (policyId: string | number) => `/policies/${policyId}/policy-statuses` as TypedPath<'/policies/{policyId}/policy-statuses'>,
  POSTINGS_ACCOUNT_AMOUNT: '/postings/account/amount' as TypedPath<'/postings/account/amount'>,
  PREFUND_HISTORIES_INVOICES_REPULL_BY_INVOICE_ID: (invoiceId: string | number) => `/prefund-histories/invoices/${invoiceId}/repull` as TypedPath<'/prefund-histories/invoices/{invoice-id}/repull'>,
  PREFUND_HISTORIES_INVOICES_RESUME_REPLENISHMENT_REJECT_BY_INVOICE_ID: (invoiceId: string | number) => `/prefund-histories/invoices/${invoiceId}/resume/replenishment/reject` as TypedPath<'/prefund-histories/invoices/{invoice-id}/resume/replenishment/reject'>,
  PREFUND_HISTORIES_INVOICES_SUMMARY_BY_INVOICE_ID: (invoiceId: string | number) => `/prefund-histories/invoices/${invoiceId}/summary` as TypedPath<'/prefund-histories/invoices/{invoice-id}/summary'>,
  PREFUND_RETURNS_APPROVE: '/prefund-returns/approve' as TypedPath<'/prefund-returns/approve'>,
  PREFUND_RETURNS_INVOICES_BY_INVOICE_ID: (invoice_id: string | number) => `/prefund-returns/invoices/${invoice_id}` as TypedPath<'/prefund-returns/invoices/{invoice_id}'>,
  PROCESSING_RULES: '/processing-rules' as TypedPath<'/processing-rules'>,
  PROCESSING_RULES_BY_ID: (id: string | number) => `/processing-rules/${id}` as TypedPath<'/processing-rules/{id}'>,
  PROCESSING_RULES_PAYOUT_RULES_BY_ID: (id: string | number) => `/processing-rules/${id}/payout-rules` as TypedPath<'/processing-rules/{id}/payout-rules'>,
  PROVIDERS: '/providers' as TypedPath<'/providers'>,
  PROVIDERS_BY_ID: (id: string | number) => `/providers/${id}` as TypedPath<'/providers/{id}'>,
  PUSH_PROVISION_EMAIL_VALIDATION: '/push-provision/email-validation' as TypedPath<'/push-provision/email-validation'>,
  RECIPIENTS_ACCOUNTS_BY_MERCHANT_CUSTOMER_ID: (merchantCustomerId: string | number) => `/recipients/${merchantCustomerId}/accounts` as TypedPath<'/recipients/{merchantCustomerId}/accounts'>,
  RECORDS_TAX_YEARS_CHANGE: '/records/tax-years-change' as TypedPath<'/records/tax-years-change'>,
  RECURRING_CONTRIBUTIONS: '/recurring-contributions' as TypedPath<'/recurring-contributions'>,
  RECURRING_CONTRIBUTIONS_INFO: '/recurring-contributions/info' as TypedPath<'/recurring-contributions/info'>,
  RECURRING_CONTRIBUTIONS_BY_ID: (id: string | number) => `/recurring-contributions/${id}` as TypedPath<'/recurring-contributions/{id}'>,
  REFRESH: '/refresh' as TypedPath<'/refresh'>,
  REGISTRATION_USERNAMES_VERIFICATION: '/registration/usernames/verification' as TypedPath<'/registration/usernames/verification'>,
  REGISTRATION_VERIFICATION: '/registration/verification' as TypedPath<'/registration/verification'>,
  RENEWALS: '/renewals' as TypedPath<'/renewals'>,
  RENEWALS_PLAN_YEAR_BY_PLAN_YEAR_ID: (planYearId: string | number) => `/renewals/plan-year/${planYearId}` as TypedPath<'/renewals/plan-year/{plan-year-id}'>,
  REPORTS_ACCOUNT_CLOSE_DETAILS: '/reports/account-close-details' as TypedPath<'/reports/account-close-details'>,
  REPORTS_CARD_STATUS_REPORT_BREAKDOWN: '/reports/card-status-report/breakdown' as TypedPath<'/reports/card-status-report/breakdown'>,
  REPORTS_CARD_STATUS_REPORT_BREAKDOWN_EXPORT_CSV: '/reports/card-status-report/breakdown/export/csv' as TypedPath<'/reports/card-status-report/breakdown/export/csv'>,
  REPORTS_CARD_STATUS_REPORT_BRIEF: '/reports/card-status-report/brief' as TypedPath<'/reports/card-status-report/brief'>,
  REPORTS_CARD_STATUS_REPORT_MULTI_EMPLOYERS_SUMMARY: '/reports/card-status-report/multi-employers/summary' as TypedPath<'/reports/card-status-report/multi-employers/summary'>,
  REPORTS_CARD_STATUS_REPORT_MULTI_EMPLOYERS_SUMMARY_EXPORT_CSV: '/reports/card-status-report/multi-employers/summary/export/csv' as TypedPath<'/reports/card-status-report/multi-employers/summary/export/csv'>,
  REPORTS_CARD_STATUS_REPORT_SUMMARY: '/reports/card-status-report/summary' as TypedPath<'/reports/card-status-report/summary'>,
  REPORTS_CARD_STATUS_REPORT_SUMMARY_EXPORT_CSV: '/reports/card-status-report/summary/export/csv' as TypedPath<'/reports/card-status-report/summary/export/csv'>,
  REPORTS_CIP_STATUS_REPORT_BREAKDOWN: '/reports/cip-status-report/breakdown' as TypedPath<'/reports/cip-status-report/breakdown'>,
  REPORTS_CIP_STATUS_REPORT_BREAKDOWN_EXPORT_CSV: '/reports/cip-status-report/breakdown/export/csv' as TypedPath<'/reports/cip-status-report/breakdown/export/csv'>,
  REPORTS_CIP_STATUS_REPORT_BRIEF: '/reports/cip-status-report/brief' as TypedPath<'/reports/cip-status-report/brief'>,
  REPORTS_CIP_STATUS_REPORT_MULTI_EMPLOYERS_SUMMARY: '/reports/cip-status-report/multi-employers/summary' as TypedPath<'/reports/cip-status-report/multi-employers/summary'>,
  REPORTS_CIP_STATUS_REPORT_MULTI_EMPLOYERS_SUMMARY_EXPORT_CSV: '/reports/cip-status-report/multi-employers/summary/export/csv' as TypedPath<'/reports/cip-status-report/multi-employers/summary/export/csv'>,
  REPORTS_CIP_STATUS_REPORT_SUMMARY: '/reports/cip-status-report/summary' as TypedPath<'/reports/cip-status-report/summary'>,
  REPORTS_CIP_STATUS_REPORT_SUMMARY_EXPORT_CSV: '/reports/cip-status-report/summary/export/csv' as TypedPath<'/reports/cip-status-report/summary/export/csv'>,
  REPORTS_CLAIM_ACTIVITY_REPORT_BREAKDOWN: '/reports/claim-activity-report/breakdown' as TypedPath<'/reports/claim-activity-report/breakdown'>,
  REPORTS_CLAIM_ACTIVITY_REPORT_BREAKDOWN_EXPORT_CSV: '/reports/claim-activity-report/breakdown/export/csv' as TypedPath<'/reports/claim-activity-report/breakdown/export/csv'>,
  REPORTS_CLAIM_ACTIVITY_REPORT_BRIEF: '/reports/claim-activity-report/brief' as TypedPath<'/reports/claim-activity-report/brief'>,
  REPORTS_CLAIM_ACTIVITY_REPORT_MULTI_EMPLOYERS_SUMMARY: '/reports/claim-activity-report/multi-employers/summary' as TypedPath<'/reports/claim-activity-report/multi-employers/summary'>,
  REPORTS_CLAIM_ACTIVITY_REPORT_MULTI_EMPLOYERS_SUMMARY_EXPORT_CSV: '/reports/claim-activity-report/multi-employers/summary/export/csv' as TypedPath<'/reports/claim-activity-report/multi-employers/summary/export/csv'>,
  REPORTS_CLAIM_ACTIVITY_REPORT_SUMMARY: '/reports/claim-activity-report/summary' as TypedPath<'/reports/claim-activity-report/summary'>,
  REPORTS_CLAIM_ACTIVITY_REPORT_SUMMARY_EXPORT_CSV: '/reports/claim-activity-report/summary/export/csv' as TypedPath<'/reports/claim-activity-report/summary/export/csv'>,
  REPORTS_CLOSES_BY_ACCOUNT: '/reports/closes-by-account' as TypedPath<'/reports/closes-by-account'>,
  REPORTS_CONTRIBUTION_INVOICE_REPORT_BREAKDOWN: '/reports/contribution-invoice-report/breakdown' as TypedPath<'/reports/contribution-invoice-report/breakdown'>,
  REPORTS_CONTRIBUTION_INVOICE_REPORT_BREAKDOWN_EXPORT_CSV: '/reports/contribution-invoice-report/breakdown/export/csv' as TypedPath<'/reports/contribution-invoice-report/breakdown/export/csv'>,
  REPORTS_CONTRIBUTION_INVOICE_REPORT_BRIEF: '/reports/contribution-invoice-report/brief' as TypedPath<'/reports/contribution-invoice-report/brief'>,
  REPORTS_CONTRIBUTION_INVOICE_REPORT_SUMMARY: '/reports/contribution-invoice-report/summary' as TypedPath<'/reports/contribution-invoice-report/summary'>,
  REPORTS_CONTRIBUTION_INVOICE_REPORT_SUMMARY_EXPORT_CSV: '/reports/contribution-invoice-report/summary/export/csv' as TypedPath<'/reports/contribution-invoice-report/summary/export/csv'>,
  REPORTS_DELINQUENT_CLAIMS_REPORT_BREAKDOWN: '/reports/delinquent-claims-report/breakdown' as TypedPath<'/reports/delinquent-claims-report/breakdown'>,
  REPORTS_DELINQUENT_CLAIMS_REPORT_BREAKDOWN_EXPORT_CSV: '/reports/delinquent-claims-report/breakdown/export/csv' as TypedPath<'/reports/delinquent-claims-report/breakdown/export/csv'>,
  REPORTS_DELINQUENT_CLAIMS_REPORT_BRIEF: '/reports/delinquent-claims-report/brief' as TypedPath<'/reports/delinquent-claims-report/brief'>,
  REPORTS_DELINQUENT_CLAIMS_REPORT_MULTI_EMPLOYERS_SUMMARY: '/reports/delinquent-claims-report/multi-employers/summary' as TypedPath<'/reports/delinquent-claims-report/multi-employers/summary'>,
  REPORTS_DELINQUENT_CLAIMS_REPORT_MULTI_EMPLOYERS_SUMMARY_EXPORT_CSV: '/reports/delinquent-claims-report/multi-employers/summary/export/csv' as TypedPath<'/reports/delinquent-claims-report/multi-employers/summary/export/csv'>,
  REPORTS_DELINQUENT_CLAIMS_REPORT_SUMMARY: '/reports/delinquent-claims-report/summary' as TypedPath<'/reports/delinquent-claims-report/summary'>,
  REPORTS_DELINQUENT_CLAIMS_REPORT_SUMMARY_EXPORT_CSV: '/reports/delinquent-claims-report/summary/export/csv' as TypedPath<'/reports/delinquent-claims-report/summary/export/csv'>,
  REPORTS_EMPLOYEE_DEMOGRAPHICS_REPORT_BREAKDOWN: '/reports/employee-demographics-report/breakdown' as TypedPath<'/reports/employee-demographics-report/breakdown'>,
  REPORTS_EMPLOYEE_DEMOGRAPHICS_REPORT_BREAKDOWN_EXPORT_CSV: '/reports/employee-demographics-report/breakdown/export/csv' as TypedPath<'/reports/employee-demographics-report/breakdown/export/csv'>,
  REPORTS_FORFEITURE_REPORT_BREAKDOWN: '/reports/forfeiture-report/breakdown' as TypedPath<'/reports/forfeiture-report/breakdown'>,
  REPORTS_FORFEITURE_REPORT_BREAKDOWN_EXPORT_CSV: '/reports/forfeiture-report/breakdown/export/csv' as TypedPath<'/reports/forfeiture-report/breakdown/export/csv'>,
  REPORTS_FORFEITURE_REPORT_SUMMARY: '/reports/forfeiture-report/summary' as TypedPath<'/reports/forfeiture-report/summary'>,
  REPORTS_FORFEITURE_REPORT_SUMMARY_EXPORT_CSV: '/reports/forfeiture-report/summary/export/csv' as TypedPath<'/reports/forfeiture-report/summary/export/csv'>,
  REPORTS_HEALTH_PLAN_ENROLLMENT_REPORT_BREAKDOWN: '/reports/health-plan-enrollment-report/breakdown' as TypedPath<'/reports/health-plan-enrollment-report/breakdown'>,
  REPORTS_HEALTH_PLAN_ENROLLMENT_REPORT_BREAKDOWN_EXPORT_CSV: '/reports/health-plan-enrollment-report/breakdown/export/csv' as TypedPath<'/reports/health-plan-enrollment-report/breakdown/export/csv'>,
  REPORTS_HEALTH_PLAN_ENROLLMENT_REPORT_BRIEF: '/reports/health-plan-enrollment-report/brief' as TypedPath<'/reports/health-plan-enrollment-report/brief'>,
  REPORTS_HEALTH_PLAN_ENROLLMENT_REPORT_SUMMARY: '/reports/health-plan-enrollment-report/summary' as TypedPath<'/reports/health-plan-enrollment-report/summary'>,
  REPORTS_HEALTH_PLAN_ENROLLMENT_REPORT_SUMMARY_EXPORT_CSV: '/reports/health-plan-enrollment-report/summary/export/csv' as TypedPath<'/reports/health-plan-enrollment-report/summary/export/csv'>,
  REPORTS_LIST_OF_ACCOUNTS: '/reports/list-of-accounts' as TypedPath<'/reports/list-of-accounts'>,
  REPORTS_PARTICIPANT_ACCOUNT_ACTIVITY_REPORT_BREAKDOWN: '/reports/participant-account-activity-report/breakdown' as TypedPath<'/reports/participant-account-activity-report/breakdown'>,
  REPORTS_PARTICIPANT_ACCOUNT_ACTIVITY_REPORT_BREAKDOWN_EXPORT_CSV: '/reports/participant-account-activity-report/breakdown/export/csv' as TypedPath<'/reports/participant-account-activity-report/breakdown/export/csv'>,
  REPORTS_PARTICIPANT_ACCOUNT_ACTIVITY_REPORT_BRIEF: '/reports/participant-account-activity-report/brief' as TypedPath<'/reports/participant-account-activity-report/brief'>,
  REPORTS_PARTICIPANT_ACCOUNT_ACTIVITY_REPORT_MULTI_EMPLOYERS_SUMMARY: '/reports/participant-account-activity-report/multi-employers/summary' as TypedPath<'/reports/participant-account-activity-report/multi-employers/summary'>,
  REPORTS_PARTICIPANT_ACCOUNT_ACTIVITY_REPORT_MULTI_EMPLOYERS_SUMMARY_EXPORT_CSV: '/reports/participant-account-activity-report/multi-employers/summary/export/csv' as TypedPath<'/reports/participant-account-activity-report/multi-employers/summary/export/csv'>,
  REPORTS_PARTICIPANT_ACCOUNT_ACTIVITY_REPORT_SUMMARY: '/reports/participant-account-activity-report/summary' as TypedPath<'/reports/participant-account-activity-report/summary'>,
  REPORTS_PARTICIPANT_ACCOUNT_ACTIVITY_REPORT_SUMMARY_EXPORT_CSV: '/reports/participant-account-activity-report/summary/export/csv' as TypedPath<'/reports/participant-account-activity-report/summary/export/csv'>,
  REPORTS_PAYROLL_CONTRIBUTIONS_REPORT_BREAKDOWN: '/reports/payroll-contributions-report/breakdown' as TypedPath<'/reports/payroll-contributions-report/breakdown'>,
  REPORTS_PAYROLL_CONTRIBUTIONS_REPORT_BREAKDOWN_EXPORT_CSV: '/reports/payroll-contributions-report/breakdown/export/csv' as TypedPath<'/reports/payroll-contributions-report/breakdown/export/csv'>,
  REPORTS_PAYROLL_CONTRIBUTIONS_REPORT_MULTI_EMPLOYERS_SUMMARY: '/reports/payroll-contributions-report/multi-employers/summary' as TypedPath<'/reports/payroll-contributions-report/multi-employers/summary'>,
  REPORTS_PAYROLL_CONTRIBUTIONS_REPORT_MULTI_EMPLOYERS_SUMMARY_EXPORT_CSV: '/reports/payroll-contributions-report/multi-employers/summary/export/csv' as TypedPath<'/reports/payroll-contributions-report/multi-employers/summary/export/csv'>,
  REPORTS_PAYROLL_CONTRIBUTIONS_REPORT_SUMMARY: '/reports/payroll-contributions-report/summary' as TypedPath<'/reports/payroll-contributions-report/summary'>,
  REPORTS_PAYROLL_CONTRIBUTIONS_REPORT_SUMMARY_EXPORT_CSV: '/reports/payroll-contributions-report/summary/export/csv' as TypedPath<'/reports/payroll-contributions-report/summary/export/csv'>,
  REPORTS_PLAN_OMNIBUS_BALANCE_REPORT_BREAKDOWN: '/reports/plan-omnibus-balance-report/breakdown' as TypedPath<'/reports/plan-omnibus-balance-report/breakdown'>,
  REPORTS_PLAN_OMNIBUS_BALANCE_REPORT_BREAKDOWN_EXPORT_CSV: '/reports/plan-omnibus-balance-report/breakdown/export/csv' as TypedPath<'/reports/plan-omnibus-balance-report/breakdown/export/csv'>,
  REPORTS_PLAN_OMNIBUS_BALANCE_REPORT_BREAKDOWN_PLANS: '/reports/plan-omnibus-balance-report/breakdown/plans' as TypedPath<'/reports/plan-omnibus-balance-report/breakdown/plans'>,
  REPORTS_PLAN_OMNIBUS_BALANCE_REPORT_SUMMARY: '/reports/plan-omnibus-balance-report/summary' as TypedPath<'/reports/plan-omnibus-balance-report/summary'>,
  REPORTS_PLAN_OMNIBUS_BALANCE_REPORT_SUMMARY_EXPORT_CSV: '/reports/plan-omnibus-balance-report/summary/export/csv' as TypedPath<'/reports/plan-omnibus-balance-report/summary/export/csv'>,
  REPORTS_PREFERENCES: '/reports/preferences' as TypedPath<'/reports/preferences'>,
  REPORTS_PREFUND_INVOICE_REPORT_BREAKDOWN: '/reports/prefund-invoice-report/breakdown' as TypedPath<'/reports/prefund-invoice-report/breakdown'>,
  REPORTS_PREFUND_INVOICE_REPORT_BREAKDOWN_EXPORT_CSV: '/reports/prefund-invoice-report/breakdown/export/csv' as TypedPath<'/reports/prefund-invoice-report/breakdown/export/csv'>,
  REPORTS_PREFUND_INVOICE_REPORT_BRIEF: '/reports/prefund-invoice-report/brief' as TypedPath<'/reports/prefund-invoice-report/brief'>,
  REPORTS_PREFUND_INVOICE_REPORT_SUMMARY: '/reports/prefund-invoice-report/summary' as TypedPath<'/reports/prefund-invoice-report/summary'>,
  REPORTS_PREFUND_INVOICE_REPORT_SUMMARY_EXPORT_CSV: '/reports/prefund-invoice-report/summary/export/csv' as TypedPath<'/reports/prefund-invoice-report/summary/export/csv'>,
  REPORTS_REPLENISHMENT_INVOICE_REPORT_BREAKDOWN: '/reports/replenishment-invoice-report/breakdown' as TypedPath<'/reports/replenishment-invoice-report/breakdown'>,
  REPORTS_REPLENISHMENT_INVOICE_REPORT_BREAKDOWN_EXPORT_CSV: '/reports/replenishment-invoice-report/breakdown/export/csv' as TypedPath<'/reports/replenishment-invoice-report/breakdown/export/csv'>,
  REPORTS_REPLENISHMENT_INVOICE_REPORT_BRIEF: '/reports/replenishment-invoice-report/brief' as TypedPath<'/reports/replenishment-invoice-report/brief'>,
  REPORTS_REPLENISHMENT_INVOICE_REPORT_SUMMARY: '/reports/replenishment-invoice-report/summary' as TypedPath<'/reports/replenishment-invoice-report/summary'>,
  REPORTS_REPLENISHMENT_INVOICE_REPORT_SUMMARY_EXPORT_CSV: '/reports/replenishment-invoice-report/summary/export/csv' as TypedPath<'/reports/replenishment-invoice-report/summary/export/csv'>,
  REPORTS_RESULTS: '/reports/results' as TypedPath<'/reports/results'>,
  REPORTS_RESULTS_BY_ID: (id: string | number) => `/reports/results/${id}` as TypedPath<'/reports/results/{id}'>,
  REPORTS_SCHEDULERS: '/reports/schedulers' as TypedPath<'/reports/schedulers'>,
  REPORTS_SCHEDULERS_BY_ID: (id: string | number) => `/reports/schedulers/${id}` as TypedPath<'/reports/schedulers/{id}'>,
  REPORTS_SCHEDULERS_DEACTIVATE_BY_ID: (id: string | number) => `/reports/schedulers/${id}/deactivate` as TypedPath<'/reports/schedulers/{id}/deactivate'>,
  REPORTS_UNDELIVERABLE_ADDRESS_REPORT_BREAKDOWN: '/reports/undeliverable-address-report/breakdown' as TypedPath<'/reports/undeliverable-address-report/breakdown'>,
  REPORTS_UNDELIVERABLE_ADDRESS_REPORT_BREAKDOWN_EXPORT_CSV: '/reports/undeliverable-address-report/breakdown/export/csv' as TypedPath<'/reports/undeliverable-address-report/breakdown/export/csv'>,
  REPORTS_UNDELIVERABLE_ADDRESS_REPORT_BRIEF: '/reports/undeliverable-address-report/brief' as TypedPath<'/reports/undeliverable-address-report/brief'>,
  RESEND_CONFIRMATION_CODE: '/resend-confirmation-code' as TypedPath<'/resend-confirmation-code'>,
  REVOKE: '/revoke' as TypedPath<'/revoke'>,
  ROLES: '/roles' as TypedPath<'/roles'>,
  ROLES_BY_PERMISSION: '/roles/by-permission' as TypedPath<'/roles/by-permission'>,
  ROLES_USER_AND_ORGANIZATION: '/roles/user-and-organization' as TypedPath<'/roles/user-and-organization'>,
  ROLES_BY_ID: (id: string | number) => `/roles/${id}` as TypedPath<'/roles/{id}'>,
  SCHEDULED_CONTRIBUTION_SEARCH_CALENDAR_CSV_REPORT_BY_CALENDAR_ID: (calendar_id: string | number) => `/scheduled-contribution-search/calendar/${calendar_id}/csv-report` as TypedPath<'/scheduled-contribution-search/calendar/{calendar_id}/csv-report'>,
  SCHEDULED_CONTRIBUTION_SEARCH_CALENDAR_EMPLOYEES_BY_CALENDAR_ID: (calendar_id: string | number) => `/scheduled-contribution-search/calendar/${calendar_id}/employees` as TypedPath<'/scheduled-contribution-search/calendar/{calendar_id}/employees'>,
  SCHEDULED_CONTRIBUTION_SEARCH_CALENDAR_SUMMARY_BY_CALENDAR_ID: (calendar_id: string | number) => `/scheduled-contribution-search/calendar/${calendar_id}/summary` as TypedPath<'/scheduled-contribution-search/calendar/{calendar_id}/summary'>,
  SCHEDULED_CONTRIBUTION_SEARCH_ORGANIZATION: '/scheduled-contribution-search/organization' as TypedPath<'/scheduled-contribution-search/organization'>,
  SCHEDULED_CONTRIBUTIONS: '/scheduled-contributions' as TypedPath<'/scheduled-contributions'>,
  SCHEDULED_CONTRIBUTIONS_ORGANIZATION: '/scheduled-contributions/organization' as TypedPath<'/scheduled-contributions/organization'>,
  SCHEDULED_CONTRIBUTIONS_BY_ID: (id: string | number) => `/scheduled-contributions/${id}` as TypedPath<'/scheduled-contributions/{id}'>,
  SCHEDULED_CONTRIBUTIONS_STATUS_BY_ID: (id: string | number) => `/scheduled-contributions/${id}/status` as TypedPath<'/scheduled-contributions/{id}/status'>,
  SEGMENTS: '/segments' as TypedPath<'/segments'>,
  SEQUENCES: '/sequences' as TypedPath<'/sequences'>,
  SEQUENCES_BY_ID: (id: string | number) => `/sequences/${id}` as TypedPath<'/sequences/{id}'>,
  SERVICE_CONFIGS: '/service-configs' as TypedPath<'/service-configs'>,
  SERVICE_CONFIGS_BY_ID: (id: string | number) => `/service-configs/${id}` as TypedPath<'/service-configs/{id}'>,
  SERVICES: '/services' as TypedPath<'/services'>,
  SERVICES_ALL: '/services/all' as TypedPath<'/services/all'>,
  SERVICES_BY_ID: (id: string | number) => `/services/${id}` as TypedPath<'/services/{id}'>,
  SIGN_UP_CONFIRMATION: '/sign-up/confirmation' as TypedPath<'/sign-up/confirmation'>,
  SIGNIN: '/signin' as TypedPath<'/signin'>,
  SIGNIN_SSO: '/signin/sso' as TypedPath<'/signin/sso'>,
  SIGNUP: '/signup' as TypedPath<'/signup'>,
  SPEND_LIMIT_PERIODS_REMAINING: '/spend-limit-periods/remaining' as TypedPath<'/spend-limit-periods/remaining'>,
  SPEND_LIMIT_PERIODS_BY_ACCOUNT_ID: (accountId: string | number) => `/spend-limit-periods/${accountId}` as TypedPath<'/spend-limit-periods/{account-id}'>,
  SPEND_LIMIT_PERIODS_REMAINING_BY_ACCOUNT_ID: (accountId: string | number) => `/spend-limit-periods/${accountId}/remaining` as TypedPath<'/spend-limit-periods/{account-id}/remaining'>,
  STATEMENTS: '/statements' as TypedPath<'/statements'>,
  TAX_FORMS: '/tax-forms' as TypedPath<'/tax-forms'>,
  TAX_FORMS_EXCESS_CONTRIBUTIONS: '/tax-forms/excess-contributions' as TypedPath<'/tax-forms/excess-contributions'>,
  TAX_FORMS_EXCESS_CONTRIBUTIONS_FILE_UPLOAD: '/tax-forms/excess-contributions/file-upload' as TypedPath<'/tax-forms/excess-contributions/file-upload'>,
  TAX_FORMS_EXCESS_CONTRIBUTIONS_BY_ID: (id: string | number) => `/tax-forms/excess-contributions/${id}` as TypedPath<'/tax-forms/excess-contributions/{id}'>,
  TAX_FORMS_MAILING_HISTORY: '/tax-forms/mailing-history' as TypedPath<'/tax-forms/mailing-history'>,
  TAX_FORMS_TAX_FORM_1099_DOWNLOAD_BY_ID: (id: string | number) => `/tax-forms/tax-form-1099/${id}/download` as TypedPath<'/tax-forms/tax-form-1099/{id}/download'>,
  TAX_FORMS_TAX_FORM_5498_DOWNLOAD_BY_ID: (id: string | number) => `/tax-forms/tax-form-5498/${id}/download` as TypedPath<'/tax-forms/tax-form-5498/{id}/download'>,
  TAX_FORMS_TAX_FORM_BANNER: '/tax-forms/tax-form-banner' as TypedPath<'/tax-forms/tax-form-banner'>,
  TAX_FORMS_TAX_FORM_BANNER_DISABLE: '/tax-forms/tax-form-banner/disable' as TypedPath<'/tax-forms/tax-form-banner/disable'>,
  TEMPLATES: '/templates' as TypedPath<'/templates'>,
  TEMPLATES_HIERARCHY: '/templates/hierarchy' as TypedPath<'/templates/hierarchy'>,
  TEMPLATES_ORGANIZATIONS_LINKED_TEMPLATES_BY_ORGANIZATION_ID: (organizationId: string | number) => `/templates/organizations/${organizationId}/linked-templates` as TypedPath<'/templates/organizations/{organization-id}/linked-templates'>,
  TEMPLATES_ORGANIZATIONS_LINKED_TEMPLATES_BY_ORGANIZATION_ID_2: (organization_id: string | number) => `/templates/organizations/${organization_id}/linked-templates` as TypedPath<'/templates/organizations/{organization_id}/linked-templates'>,
  TEMPLATES_UNLINKING_BY_PLAN_ID: (planId: string | number) => `/templates/${planId}/unlinking` as TypedPath<'/templates/{plan-id}/unlinking'>,
  TIERS_DEDUCTIBLES: '/tiers/deductibles' as TypedPath<'/tiers/deductibles'>,
  TOKENS: '/tokens' as TypedPath<'/tokens'>,
  TRADES: '/trades' as TypedPath<'/trades'>,
  TRADES_AMOUNTS: '/trades/amounts' as TypedPath<'/trades/amounts'>,
  TRANSACTIONS: '/transactions' as TypedPath<'/transactions'>,
  TRANSACTIONS_MANUAL_TRANSACTIONS: '/transactions/manual-transactions' as TypedPath<'/transactions/manual-transactions'>,
  TRANSACTORS_BY_TRANSACTOR_ID: (transactorId: string | number) => `/transactors/${transactorId}` as TypedPath<'/transactors/{transactor-id}'>,
  TRANSFER_CLAIMS_BY_CLAIM_ID: (claimId: string | number) => `/transfer/claims/${claimId}` as TypedPath<'/transfer/claims/{claim-id}'>,
  TRANSFER_CLAIMS_ACCOUNTS_BY_CLAIM_ID: (claimId: string | number) => `/transfer/claims/${claimId}/accounts` as TypedPath<'/transfer/claims/{claim-id}/accounts'>,
  TRANSFER_EMPLOYEES_ACCOUNTS_BY_EMPLOYEE_ID: (employeeId: string | number) => `/transfer/employees/${employeeId}/accounts` as TypedPath<'/transfer/employees/{employee-id}/accounts'>,
  TRIGGERS: '/triggers' as TypedPath<'/triggers'>,
  UI_EMPLOYEES: '/ui/employees' as TypedPath<'/ui/employees'>,
  UI_EMPLOYEES_BY_EMPLOYEE_ID: (employeeId: string | number) => `/ui/employees/${employeeId}` as TypedPath<'/ui/employees/{employee-id}'>,
  UI_EMPLOYEES_EXTENDED_BY_EMPLOYEE_ID: (employeeId: string | number) => `/ui/employees/${employeeId}/extended` as TypedPath<'/ui/employees/{employee-id}/extended'>,
  UI_EMPLOYEES_SSN_BY_EMPLOYEE_ID: (employeeId: string | number) => `/ui/employees/${employeeId}/ssn` as TypedPath<'/ui/employees/{employee-id}/ssn'>,
  UI_ORGANIZATIONS_TERMINATION_BY_ORGANIZATION_ID: (organizationId: string | number) => `/ui/organizations/${organizationId}/termination` as TypedPath<'/ui/organizations/{organization-id}/termination'>,
  UI_PAYROLL_CALENDARS_ORGANIZATIONS_BY_ORGANIZATION_ID: (organizationId: string | number) => `/ui/payroll-calendars/organizations/${organizationId}` as TypedPath<'/ui/payroll-calendars/organizations/{organization-id}'>,
  UI_PAYROLL_CALENDARS_BY_ID: (id: string | number) => `/ui/payroll-calendars/${id}` as TypedPath<'/ui/payroll-calendars/{id}'>,
  UNMATCHED_PUSH_TRANSACTIONS_BY_ORGANIZATION: '/unmatched-push-transactions/by-organization' as TypedPath<'/unmatched-push-transactions/by-organization'>,
  UNMATCHED_PUSH_TRANSACTIONS_FUNDS_HISTORY_SEARCH: '/unmatched-push-transactions/funds-history-search' as TypedPath<'/unmatched-push-transactions/funds-history-search'>,
  UNMATCHED_PUSH_TRANSACTIONS_TOTAL_BALANCE: '/unmatched-push-transactions/total-balance' as TypedPath<'/unmatched-push-transactions/total-balance'>,
  UNMATCHED_PUSH_TRANSACTIONS_TOTAL_BALANCE_AGGREGATED: '/unmatched-push-transactions/total-balance/aggregated' as TypedPath<'/unmatched-push-transactions/total-balance/aggregated'>,
  V2_ACTIVITIES_ACCOUNTS_BY_ACCOUNT_ID: (accountId: string | number) => `/v2/activities/accounts/${accountId}` as TypedPath<'/v2/activities/accounts/{account-id}'>,
  V2_DEPENDENTS: '/v2/dependents' as TypedPath<'/v2/dependents'>,
  V2_DEPENDENTS_EMPLOYEE_BY_EMPLOYEE_ID: (employeeId: string | number) => `/v2/dependents/employee/${employeeId}` as TypedPath<'/v2/dependents/employee/{employee-id}'>,
  V2_DEPENDENTS_NAMES: '/v2/dependents/names' as TypedPath<'/v2/dependents/names'>,
  V2_DEPENDENTS_BY_DEPENDENT_ID: (dependentId: string | number) => `/v2/dependents/${dependentId}` as TypedPath<'/v2/dependents/{dependent-id}'>,
  V2_DEPENDENTS_ADD_CARD_BY_DEPENDENT_ID: (dependentId: string | number) => `/v2/dependents/${dependentId}/add-card` as TypedPath<'/v2/dependents/{dependent-id}/add-card'>,
  V2_DEPENDENTS_DEACTIVATE_BY_DEPENDENT_ID: (dependentId: string | number) => `/v2/dependents/${dependentId}/deactivate` as TypedPath<'/v2/dependents/{dependent-id}/deactivate'>,
  V2_DEPENDENTS_REACTIVATE_BY_DEPENDENT_ID: (dependentId: string | number) => `/v2/dependents/${dependentId}/reactivate` as TypedPath<'/v2/dependents/{dependent-id}/reactivate'>,
  V2_SERVICES_ALL: '/v2/services/all' as TypedPath<'/v2/services/all'>,
  V2_TAX_FORMS: '/v2/tax-forms' as TypedPath<'/v2/tax-forms'>,
  VENDORS: '/vendors' as TypedPath<'/vendors'>,
  ZENDESK_MESSAGING_TOKEN: '/zendesk/messaging-token' as TypedPath<'/zendesk/messaging-token'>,
} as const;

/**
 * Extract response type for a path and method
 */
export type PathResponse<P extends string, M extends string = 'GET'> = 
  P extends keyof PathTypes
    ? M extends keyof PathTypes[P]
      ? PathTypes[P][M] extends { response: infer R }
        ? R
        : any
      : any
    : any;

/**
 * Extract request type for a path and method
 */
export type PathRequest<P extends string, M extends string = 'POST'> = 
  P extends keyof PathTypes
    ? M extends keyof PathTypes[P]
      ? PathTypes[P][M] extends { request: infer R }
        ? R
        : any
      : any
    : any;
